/* The cart (drawer and /cart page). REDO 5 Oct 2026, SYSTEM lane (brief 19): banStatic() makes the banner one still line when its two words match (R/REQUESTS.md, shared layer 10:20pm). Was generated by site-2026-09-21/tools/cart-theme-emit.mjs. */
(function(){var CFG=window.OpusCartCFG;if(!CFG||window.OpusCart)return;
'use strict';
var MAXQ = 10;
var P = CFG.products;
var S = CFG.s;
var doc = document;
var win = window;
var reduced = false;
try { reduced = win.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
function esc(s) {
return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function has(id) { return S[id] != null && String(S[id]).indexOf('⟦') !== 0; }
function txt(id, v) {
var s = S[id];
if (s == null) s = '⟦TO BE WRITTEN: ' + id + '⟧';
return String(s).replace(/\{(\w+)\}/g, function (m, k) { return v && v[k] != null ? String(v[k]) : m; })
.replace(/\*\*(.+?)\*\*/g, '$1');
}
function htm(id, v) {
var s = S[id];
if (s == null) s = '⟦TO BE WRITTEN: ' + id + '⟧';
s = esc(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
return s.replace(/\{(\w+)\}/g, function (m, k) { return v && v[k] != null ? esc(v[k]) : m; });
}
function money(c) {
var n = (Math.round(c) / 100).toFixed(2);
return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function moneyWhole(c) { return money(c).replace(/\.00$/, ''); }
function now() { return Date.now(); }
function clampQ(q) { q = parseInt(q, 10); if (!(q >= 1)) q = 1; return q > MAXQ ? MAXQ : q; }
function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
function term(l) { return l.product && P[l.product] ? P[l.product].terms[l.term] : null; }
/* push 26 (Mike, 6 Oct 2026, Q13 "Same 30 days"): the 24-month prepaid plan is a term like the 12-month one */
function isPre(t) { return t === '12' || t === '24'; }
function isSub(t) { return t === 'monthly' || t === 'bimonthly' || isPre(t); }
function isDelivery(t) { return t === 'monthly' || t === 'bimonthly'; }
function itPlan(it) { return it && it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? String(it.selling_plan_allocation.selling_plan.id) : ''; }
function overlay() {
var C = win.OpusCatalog && win.OpusCatalog.products;
if (!C) return;
var n = function (x) { return typeof x === 'number' && isFinite(x) && x >= 0 ? x : null; };
CFG.order.forEach(function (id) {
var o = C[id], p = P[id];
if (!o || !p) return;
var T = p.terms;
if (o.url) p.url = o.url;
if (typeof o.available === 'boolean') p.available = o.available;   // a sold-out product is never suggested
if (o.productId) for (var k in T) if (!isPre(k)) T[k].pid = String(o.productId);
if (o.variantId) T.once.variant = String(o.variantId);
var once = n(o.price);
if (once != null) T.once.priceC = once;
var pl = o.plans || {};
['monthly', 'bimonthly'].forEach(function (k) {
if (!T[k]) return;
var x = pl[k];
if (!x || !x.id) { if (k === 'bimonthly' && x && 'id' in x) delete T[k]; return; }
var t = T[k], was = t.priceC;
t.variant = T.once.variant; t.plan = String(x.id);
if (n(x.price) != null) t.priceC = x.price;
if (once != null) { if (t.wasC !== once || was !== t.priceC) t.pct = Math.round(100 - t.priceC * 100 / once); t.wasC = once; }
});
var y = o.prepaid, Y = T['12'];
if (y && Y && y.variantId && y.planId) {
Y.variant = String(y.variantId); Y.plan = String(y.planId);
if (y.productId) Y.pid = String(y.productId);
if (n(y.price) != null && y.price !== Y.totalC) {
Y.totalC = y.price; Y.priceC = Math.round(y.price / (Y.months || 12));
if (once != null) Y.pct = Math.round(100 - Y.priceC * 100 / once);
}
if (once != null) Y.wasC = once;
}
});
}
function num(x) { return typeof x === 'number' && isFinite(x) && x > 0 ? x : null; }
function all3() {
var A = CFG.all3, L = CFG.all3live;
delete P.all3;
if (!A || !L || !L.m || !L.y) return;
var m = L.m, y = L.y, parts = (A.parts || []).filter(function (id) { return P[id] && P[id].terms.once && P[id].terms.monthly; });
if (!parts.length || parts.length !== (A.parts || []).length) return;
if (!m.v || !m.plan || !y.v || !y.plan || String(m.v) === String(y.v)) return;
var mC = num(m.price), yC = num(y.price);
if (mC == null || yC == null) return;
var onceC = 0, moC = 0;
parts.forEach(function (id) { onceC += P[id].terms.once.priceC; moC += P[id].terms.monthly.priceC; });
var months = (P[parts[0]].terms['12'] && P[parts[0]].terms['12'].months) || 12;
var pct = function (c) { return Math.round(100 - c * 100 / onceC); };
P.all3 = {
id: 'all3', bundle: true, parts: parts, url: A.url || '/products',
name: has('products.plan.names.all') ? txt('products.plan.names.all') : parts.map(function (id) { return P[id].name; }).join(' + '),
img: m.img || null, imgW: 80, imgH: 80, available: m.available !== false && y.available !== false,
onceC: onceC, extraC: moC - mC > 0 ? moC - mC : (A.extraC || 0),
terms: {
monthly: { variant: String(m.v), plan: String(m.plan), priceC: mC, wasC: onceC, pct: pct(mC), days: P[parts[0]].terms.monthly.days || 30, pid: String(m.pid || '') },
'12': { variant: String(y.v), plan: String(y.plan), totalC: yC, priceC: Math.round(yC / months), wasC: onceC, pct: pct(Math.round(yC / months)), months: months, pid: String(y.pid || '') },
},
};
}
function isBundle(l) { return !!(l && l.product && P[l.product] && P[l.product].bundle); }
function partsOf(l) { return !l || !l.product ? [] : P[l.product].bundle ? P[l.product].parts : [l.product]; }
var VP = {};                                  // "variant:plan" -> {product, term}
var YEARPLAN = {};                            // prepaid variant -> its plan (KB-AUDIT cart.md CHANGE 7)
var PLANVAR = {};                             // a prepaid plan -> its own variant (A1: an add that names the plan on the wrong variant)
function index() {
VP = {}; YEARPLAN = {}; PLANVAR = {};
for (var id in P) for (var k in P[id].terms) {
var t = P[id].terms[k];
VP[t.variant + ':' + (t.plan || '')] = { product: id, term: k };
if (isPre(k) && t.plan) { YEARPLAN[t.variant] = t.plan; PLANVAR[t.plan] = t.variant; }
}
}
function yearSaving(p, basis) {
basis = basis || (CFG.savingBasis === 'monthly' ? 'monthly' : 'once');
var y = p.terms['12'], b = p.terms[basis] || (basis === 'once' && p.onceC ? { priceC: p.onceC } : null);   // A1: the bundle has no one-time term
if (!y || !b || !(b.priceC > 0)) return null;
var months = y.months || 12, wasC = b.priceC * months, saveC = wasC - y.totalC;
return { pct: Math.round(saveC / wasC * 100), saveC: saveC, wasC: wasC };
}
var state = { cart: null, lines: [], country: CFG.country || null };
var server = null;              // the newest cart the store has sent back
var errors = {};
var lastSync = { sub: 0, auto: 0, code: 0, codeTitle: null, total: 0, a3: 0 };
function derive(cart) {
var seen = {}, out = [];
((cart && cart.items) || []).forEach(function (it) {
var plan = itPlan(it), v = String(it.variant_id);
var m = VP[v + ':' + plan];
var base = m ? m.product + '-' + m.term : 'v' + v + '-' + (plan || '0');
var u = base, n = 2;
while (seen[u]) u = base + '-' + (n++);
seen[u] = 1;
var codes = [], a3C = 0;
(it.line_level_discount_allocations || it.discount_allocations || []).forEach(function (d) {
var a = d.discount_application || {};
if (isA3(a)) { a3C += d.amount || 0; return; }
if (a.type === 'discount_code' && a.title && codes.indexOf(a.title) < 0) codes.push(a.title);
});
out.push({
uid: u, key: it.key, product: m ? m.product : null, term: m ? m.term : null, qty: it.quantity,
variant: v, plan: plan || null, lineC: it.final_line_price + a3C, origC: it.original_line_price, a3C: a3C, codes: codes, props: it.properties || null,
gen: m ? null : { title: it.product_title || it.title, url: it.url, img: it.image || (it.featured_image && it.featured_image.url) || '', planName: plan ? it.selling_plan_allocation.selling_plan.name : '' },
});
});
return out;
}
/* Mike, 4 Oct 2026, 7:27pm: no ALL THREE product. The store's discount code (CFG.all3code, "ALLTHREE", the Regios
   app) takes the all-three saving when all three products are in the cart on subscription plans. It comes back on
   each line's discount allocations; the cart shows the lines before it and one row, "All three together", with the
   summed amount the store actually took (never a typed figure). */
/* store lane, 7:49pm: the code only when all three are on the SAME plan (all Subscribe & Save, or all on the prepaid
   year); a cart mixing the two gets none, by design. Each plan has its own code name (CFG.all3code, CFG.all3codeYear),
   the same "ALLTHREE" for now */
function a3Codes() { return [CFG.all3code, CFG.all3codeYear].filter(Boolean).map(function (c) { return String(c).toUpperCase(); }); }
function isA3(a) { return !!(a && a.type === 'discount_code' && a3Codes().indexOf(String(a.title || a.code || '').toUpperCase()) >= 0); }
function a3Of(cart) {
var s = 0;
((cart && cart.items) || []).forEach(function (it) { (it.line_level_discount_allocations || it.discount_allocations || []).forEach(function (d) { if (isA3(d.discount_application)) s += d.amount || 0; }); });
return s;
}
function a3Plan() {
var ids = CFG.order || ['broq', 'nmn', 'spmd'], by = {};
state.lines.forEach(function (l) { if (l.product && isSub(l.term)) { (by[l.term] = by[l.term] || {})[l.product] = 1; } });
/* store lane, 8:33pm: the code takes $10 off a full set on one plan; other lines beside the set (an annual BROQ with
   three monthly) do not stop it. A full monthly set first, then a full annual one; a set split across plans gets none */
var pick = a3Whole(by, ids);
return pick.length ? pick[0] : null;
}
/* every plan that holds a whole set (a cart can hold a monthly set and an annual set: $130 off) */
function a3Whole(by, ids) {
if (!by) { ids = CFG.order || ['broq', 'nmn', 'spmd']; by = {}; state.lines.forEach(function (l) { if (l.product && isSub(l.term)) { (by[l.term] = by[l.term] || {})[l.product] = 1; } }); }
return ['monthly', '12'].filter(function (t) { return by[t] && ids.every(function (id) { return by[t][id]; }); });
}
/* review E, 10:07pm: the last known code share per plan, used only while a change is on its way to the store and only
   for a plan whose set is still whole */
function a3Kept() { var out = {}; a3Whole().forEach(function (t) { out[t] = (lastSync.a3by && lastSync.a3by[t]) || 0; }); return out; }
function a3Qualifies() { return !!a3Plan(); }
function a3Off() { if (synced()) return a3Of(state.cart); var k = a3Kept(), w = a3Whole().length; return (k.monthly || 0) + (k['12'] || 0) + (w && lastSync.a3by ? lastSync.a3by._o || 0 : 0); }   /* review F: a share the store put on another line still counts toward the total */
var a3Tried = '', a3Fail = 0;
function a3Sync(cart) {
if (!cart || !synced() || !a3Codes().length) return;
/* coordinator, 9:35pm (WORK's 8:13pm fix): the page's own Liquid cart lists no discount codes, so deciding on it would
   post ALLTHREE alone and wipe a code the buyer brought; decide only on the store's /cart.js answer */
if (!Array.isArray(cart.discount_codes)) return;
var pl = a3Plan(), C = pl ? (pl === '12' ? CFG.all3codeYear : CFG.all3code) : null;
var codes = (cart.discount_codes || []).map(function (x) { return String(x.code); });
var U = C ? String(C).toUpperCase() : null, all = a3Codes();
var mine = codes.filter(function (c) { return all.indexOf(c.toUpperCase()) >= 0; });
if (U ? (mine.length === 1 && mine[0].toUpperCase() === U) : !mine.length) { a3Tried = ''; return; }
var next = codes.filter(function (c) { return all.indexOf(c.toUpperCase()) < 0; });
/* store lane, 8:33pm, one code per cart: a code the shopper typed that the store is honouring is never replaced by
   ours (taking ours off when the set breaks still happens). A typed code the store does not apply to this cart (Shopify
   marks it applicable: false) saves nothing, so the set's code goes in beside it */
var live = (cart.discount_codes || []).some(function (x) { return x.applicable !== false && all.indexOf(String(x.code).toUpperCase()) < 0; });
if (C && !mine.length && live) { a3Tried = ''; return; }
if (C) next.push(C);
var want = !!C;
var sig = (want ? '+' : '-') + next.join(',') + '|' + cart.item_count + '|' + cart.items_subtotal_price;
if (a3Tried === sig) return;                                // this exact change was tried already: never loop
a3Tried = sig;
/* review B, 9pm: a network failure on this one update would otherwise block the set's code until the cart changed;
   allow two retries (the refresh after a failure calls a3Sync again), then stop, so it can never loop */
enqueue(function () { return api('/cart/update.js', { discount: next.join(',') }); }, false)
.then(function () { a3Fail = 0; }, function () { if (a3Fail++ < 2) a3Tried = ''; });
}
function cartLevel(cart) {
var code = 0, auto = 0, title = null;
((cart && cart.cart_level_discount_applications) || []).forEach(function (a) {
var amt = a.total_allocated_amount || 0;
if (a.type === 'discount_code') { code += amt; title = title || a.title; } else auto += amt;
});
return { code: code, auto: auto, title: title };
}
var local = false;
function synced() { return !!state.cart && pending === 0 && !local; }
function unitC(l) {
var t = term(l);
if (!t) return l.qty ? Math.round(l.lineC / l.qty) : 0;
return isPre(l.term) ? t.totalC : t.priceC;
}
function lineWas(l) {
var t = term(l);
if (!t) return 0;
if (isDelivery(l.term)) return (t.wasC || 0) * l.qty;
if (l.term === '12') { var ym = yearSaving(P[l.product]); return ym ? ym.wasC * l.qty : 0; }
if (l.term === '24') { var b24 = P[l.product].terms[CFG.savingBasis === 'monthly' ? 'monthly' : 'once']; return b24 && b24.priceC > 0 ? b24.priceC * (t.months || 24) * l.qty : 0; }   /* push 26: as yearSaving, over 24 months */
return 0;
}
function linesC() { return state.lines.reduce(function (a, l) { return a + l.lineC; }, 0); }
function count() { return state.lines.reduce(function (a, l) { return a + l.qty; }, 0); }
function hasSub() { return state.lines.some(function (l) { return !!l.plan || isSub(l.term); }); }
function abroad() { return !!(state.country && state.country !== CFG.freeCountry); }
function estOff(kind) {
var s = linesC(), last = lastSync[kind];
if (!last || !(lastSync.sub > 0)) return 0;
return Math.max(last, Math.round(last * s / lastSync.sub));
}
function subtotalShown() {
if (synced()) return state.cart.items_subtotal_price + a3Of(state.cart) - cartLevel(state.cart).auto;
return linesC() - estOff('auto');
}
function codeOff() { return synced() ? cartLevel(state.cart).code : estOff('code'); }
function codeTitle() { return synced() ? cartLevel(state.cart).title : lastSync.codeTitle; }
function shipBase() { return subtotalShown() - codeOff() - a3Off(); }   /* brief 53: never total_price; once /cart/shipping_rates.json has run, the store's POST answers add the shipping rate into it ($70 on a $63 cart) */
function freeShip() {
if (abroad()) return false;
return hasSub() || shipBase() >= CFG.freeOverC;
}
var quote = { key: null, c: null };
function quoteKey() {
var c = state.cart;
return c ? (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join(',') + '#' + c.total_price : '';
}
function wantQuote() { return synced() && state.lines.length && !abroad() && !freeShip() && CFG.shipQuote; }
function getQuote() {
if (!wantQuote()) return;
var k = quoteKey();
if (quote.key === k) return;
quote.key = k; quote.c = null;
var a = CFG.shipQuote, qs = ['country', 'province', 'zip'].map(function (f) {
return 'shipping_address%5B' + f + '%5D=' + encodeURIComponent(a[f] || '');
}).join('&');
fetch('/cart/shipping_rates.json?' + qs, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (j) {
if (quote.key !== k) return;
var min = null;
((j && j.shipping_rates) || []).forEach(function (r) {
var c = Math.round(parseFloat(r.price) * 100);
if (isFinite(c) && c >= 0 && (min == null || c < min)) min = c;
});
quote.c = min;
if (min != null) render();
}).catch(function () {});
}
function shipC() { return wantQuote() && quote.key === quoteKey() ? quote.c : null; }
function itemOf(l, q) {
var t = term(l), qty = q == null ? l.qty : q;
return { item_id: l.variant || (t && t.variant), item_name: l.product ? P[l.product].name : (l.gen && l.gen.title) || '',
item_variant: l.term || l.plan || 'once', item_brand: CFG.brand, price: unitC(l) / 100, quantity: qty };
}
function track(name, payload) {
payload = payload || {};
var items = payload.items || [];
try {
var dl = win.dataLayer = win.dataLayer || [];
if (items.length) dl.push({ ecommerce: null });
var o = { event: name };
for (var k in payload) if (k !== 'items') o[k] = payload[k];
if (items.length) { o.items = items; o.ecommerce = { currency: 'USD', value: payload.value, items: items }; }
dl.push(o);
} catch (e) {}
}
function cartPayload(extra) {
var o = { items: state.lines.map(function (l) { return itemOf(l); }), value: (subtotalShown() - codeOff() - a3Off()) / 100 };
for (var k in extra || {}) o[k] = extra[k];
return o;
}
function api(path, body, tries) {
tries = tries || 0;
var ac = !body && typeof AbortController === 'function' ? new AbortController() : null;
var to = ac ? setTimeout(function () { ac.abort(); }, 15000) : 0;
return fetch(path, {
method: body ? 'POST' : 'GET', credentials: 'same-origin', signal: ac ? ac.signal : undefined,
headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
body: body ? JSON.stringify(body) : undefined,
}).then(function (r) {
return r.text().then(function (t) {
var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {}
if (r.status === 429 && tries < 2) return new Promise(function (res) { setTimeout(res, 1000 * (tries + 1)); }).then(function () { return api(path, body, tries + 1); });
if (!r.ok) { var err = new Error((j && (j.description || j.message)) || ('http ' + r.status)); err.status = r.status; err.body = j; throw err; }
return j;
});
}).then(function (j) { clearTimeout(to); return j; }, function (e) { clearTimeout(to); throw e; });
}
function getCart() { return api('/cart.js'); }
function findItem(variant, plan) {
return ((server && server.items) || []).filter(function (it) { return String(it.variant_id) === String(variant) && itPlan(it) === (plan || ''); })[0];
}
/* push 23: a discount that covers only part of a quantity (ALLTHREE on 2 BROQ beside 1 NMN and 1 SPMD) makes the store
   split the product into two lines with their own keys. A change aims at the clicked line's own key; the first line with
   the same product and plan only when that key is gone */
function byKey(key, variant, plan) {
var k = key && ((server && server.items) || []).filter(function (it) { return it.key === key; })[0];
return k && String(k.variant_id) === String(variant) && itPlan(k) === (plan || '') ? k : findItem(variant, plan);
}
var chain = Promise.resolve(), pending = 0, latest = null, failed = false;
function errCode(e) {
if (!e || !e.status) return 'NET';
var d = String((e.body && (e.body.description || e.body.message)) || e.message || '');
if (e.status === 422 && /selling.?plan|subscription/i.test(d)) return 'PLAN';
if (e.status === 422 && /sold out|only \d+|can only add|can.t add|cannot add|not available|unavailable|inventory|in stock/i.test(d)) return 'SOLDOUT';
return 'ERROR';
}
function enqueue(fn, failUid) {
pending++;
var p = chain.then(fn);
chain = p.then(function (c) { if (c && c.items) { server = c; latest = c; } }, function (e) {
failed = true;
if (failUid === '_add') errors._add = { code: errCode(e), msg: e && e.body && e.body.description ? String(e.body.description) : '' };
else if (failUid !== false) errors[failUid || '_all'] = errCode(e);
track('cart_error', { code: (e && e.status) || 'NETWORK', reason: errCode(e), line: failUid || null, message: String(e && e.message) });
}).then(function () {
if (--pending) return null;
var c = latest, f = failed; latest = null; failed = false;
if (c && !f) { apply(c); return null; }
return getCart().then(function (x) { server = x; apply(x); }, function () { render(); setTimeout(refresh, 2000); });
});
return p;
}
function opQty(l, q) {
var v = l.variant, pl = l.plan, key = l.key, gen = !!l.gen;
return function () {
var own = key && ((server && server.items) || []).some(function (x) { return x.key === key; });
var it = gen || own ? null : findItem(v, pl);
var id = own ? key : it ? it.key : key;
if (!id) return getCart();
return api('/cart/change.js', { id: id, quantity: q });
};
}
/* push 25: a plan change by key moves every unit of a line the store shows as two (see byKey), so a row with such a
   twin moves only its own units: added on the new plan, then taken off this row, as a variant change does */
function twinOf(it) {
var pj = JSON.stringify(it.properties || {});
return ((server && server.items) || []).some(function (x) { return x.key !== it.key && String(x.variant_id) === String(it.variant_id) && itPlan(x) === itPlan(it) && JSON.stringify(x.properties || {}) === pj; });
}
function opPlan(variant, fromPlan, toPlan, key) {
var move = opSwap(variant, fromPlan, variant, toPlan, key);
return function () {
var it = byKey(key, variant, fromPlan);
if (!it) return getCart();
if (twinOf(it)) return move();
return api('/cart/change.js', { id: it.key, quantity: it.quantity, selling_plan: toPlan ? Number(toPlan) : null }).then(function (c) {
server = c;
var dup = c.items.filter(function (x) { return String(x.variant_id) === String(variant) && itPlan(x) === (toPlan || ''); });
if (dup.length < 2) return c;
var up = {};
up[dup[0].key] = Math.min(MAXQ, dup.reduce(function (a, x) { return a + x.quantity; }, 0));
for (var i = 1; i < dup.length; i++) up[dup[i].key] = 0;
return api('/cart/update.js', { updates: up });
});
};
}
function opSwap(fromV, fromPlan, toV, toPlan, key) {
return function () {
var it = byKey(key, fromV, fromPlan);
if (!it) return getCart();
var add = { id: Number(toV), quantity: it.quantity };
if (toPlan) add.selling_plan = Number(toPlan);
withProps(add, it.properties);                        // the line keeps the surface it came from (CA6)
return api('/cart/add.js', { items: [add] }).then(getCart).then(function (c) {
server = c;
var old = byKey(it.key, fromV, fromPlan);
if (!old) return c;
if (old.key === it.key || old.quantity >= it.quantity) return api('/cart/change.js', { id: old.key, quantity: Math.max(0, old.quantity - it.quantity) });   /* push 23: only what moved */
var left = it.quantity, up = {};   /* push 25: the key changed and the units sit on more than one item: take them off in turn */
c.items.forEach(function (x) { if (left > 0 && String(x.variant_id) === String(fromV) && itPlan(x) === (fromPlan || '')) { var d = Math.min(left, x.quantity); up[x.key] = x.quantity - d; left -= d; } });
return api('/cart/update.js', { updates: up });
});
};
}
function srcProp(src) { var v = String(src || '').replace(/[^\w-]/g, '').slice(0, 32); return v ? { _src: v } : null; }
function withProps(it, props) {
var ex = findItem(it.id, it.selling_plan ? String(it.selling_plan) : '');
var p = ex ? ex.properties : props;
if (p && typeof p === 'object' && Object.keys(p).length) it.properties = p; else delete it.properties;
return it;
}
function opAdd(items, props) {
return function () {
items.forEach(function (it, i) { withProps(it, Array.isArray(props) ? props[i] : props); });   // K-5: one per item
return api('/cart/add.js', { items: items }).then(function () { return getCart().catch(function () { return null; }); });
};
}
var undoBuf = null, undoTimer = null, lastFree = null;
var pendingFocus = null;
function focusKey(k) { pendingFocus = k; }
function changed(announce) {
local = true;
keepOrder();
render();
if (announce) say(announce);
var f = freeShip();
if (lastFree === false && f === true && state.lines.length) {
track('cart_ship_threshold', { value: shipBase() / 100, reason: hasSub() ? 'sub' : 'threshold' });
}
lastFree = f;
}
function mkLine(product, t, qty) {
var T = P[product].terms[t];
var l = { uid: product + '-' + t, key: null, product: product, term: t, qty: qty, variant: T.variant, plan: T.plan || null, lineC: 0, origC: 0, codes: [], gen: null };
l.lineC = l.origC = unitC(l) * qty;
return l;
}
function findLine(id) { return state.lines.filter(function (l) { return l.uid === id; })[0]; }
function findPT(product, t) { return state.lines.filter(function (l) { return l.product === product && l.term === t; })[0]; }
function reprice(l) { if (term(l)) { l.lineC = l.origC = unitC(l) * l.qty; } else if (l.qty) { var u = Math.round(l.lineC / (l._q || l.qty)); l.lineC = l.origC = u * l.qty; } }
var adding = 0;
function addItems(items, opts) {
opts = opts || {};
errors = {};
if (opts.owned) keepOwned(opts.owned);                                // K1: known before the drawer paints
var names = [], tr = [], marks = [], fresh = [];
var clean = [], srcs = [];
(items || []).forEach(function (x) {
if (!x || !x.id) return;
var q = clampQ(x.quantity || 1), it = { id: Number(x.id), quantity: q };
var sp = x.selling_plan ? String(x.selling_plan) : '';
if (!sp && YEARPLAN[String(x.id)]) sp = YEARPLAN[String(x.id)];      // a prepaid year never goes in without its plan
if (sp) it.selling_plan = Number(sp);
if (sp && !VP[String(x.id) + ':' + sp] && PLANVAR[sp]) it.id = Number(PLANVAR[sp]);
clean.push(it);
srcs.push(srcProp(x.source || opts.source || 'api'));
var m = VP[String(it.id) + ':' + sp];
if (!m) return;
var ex = findPT(m.product, m.term);
var isNew = !ex, was = ex ? ex.qty : 0;
if (ex) { ex.qty = clampQ(ex.qty + q); reprice(ex); }
else { ex = mkLine(m.product, m.term, q); fresh.push(ex); }
ex.pend = true; marks.push({ l: ex, isNew: isNew, was: was });
names.push(P[m.product].name);
tr.push(itemOf(ex, q));
});
if (!clean.length) return Promise.reject(new Error('OpusCart.add: no items'));
state.lines = fresh.concat(state.lines);                              // K-2: named order, on top
adding++;
var p = enqueue(opAdd(clean, srcs), '_add');
changed(null);
if (opts.open !== false) open(opts.opener);
return p.then(function (c) {
adding--;
marks.forEach(function (m) { m.l.pend = false; });
track('add_to_cart', { items: tr, value: tr.reduce(function (a, x) { return a + x.price * x.quantity; }, 0), source: opts.source || 'api' });
render();
if (names.length) say(txt('cart.sr.added', { name: names.join(', '), amount: money(c && c.items ? c.items_subtotal_price - cartLevel(c).auto : subtotalShown()) }));
wantAttrsFrom(opts.attributes);                                     // K4: only once the store has said yes
flushAttrs();
return c;
}, function (e) {
adding--;
marks.forEach(function (m) {
m.l.pend = false;
if (m.isNew) state.lines = state.lines.filter(function (x) { return x !== m.l; });
else { m.l.qty = m.was; reprice(m.l); }
});
focusKey('title');
render();
if (e && e.status) return { ok: false, error: errCode(e), status: e.status };
throw e;
});
}
function addByKey(product, plan, qty, opts) {
var t = P[product] && P[product].terms[plan || 'monthly'];
if (!t) return Promise.reject(new Error('OpusCart.add: unknown ' + product + '/' + plan));
var it = { id: Number(t.variant), quantity: clampQ(qty || 1) };
if (t.plan) it.selling_plan = Number(t.plan);
return addItems([it], opts);
}
function setQty(id, q) {
var l = findLine(id);
if (!l) { render(); return; }                                      /* brief 53: every line has a stepper, as Timeline's do (a quantity change by key keeps the line's selling plan); the field snaps back if the line is gone */
var from = l.qty; q = clampQ(q);
if (q === from) { render(); return; }
l._q = from; l.qty = q; reprice(l); delete l._q;
errors = {}; local = true;
var ti = itemOf(l), td = itemOf(l, Math.abs(q - from)), tv = unitC(l) * Math.abs(q - from) / 100;
enqueue(opQty(l, q), l.uid).then(function () {
track('cart_qty_change', { items: [ti], from: from, to: q });
if (q > from) track('add_to_cart', { items: [td], value: tv, source: 'stepper' });
else track('remove_from_cart', { items: [td], value: tv });
}, function () {});
changed(txt('cart.sr.updated', { amount: money(subtotalShown()) }));
}
function setTerm(id, to, via) {
var l = findLine(id);
if (!l || !l.product || l.term === to || !P[l.product].terms[to]) return;
if (to === '12' && !CFG.allowPrepaidSwitch) return;
var from = l.term, T = P[l.product].terms, f = T[from], t = T[to];
errors = {}; local = true;
var done = f.variant === t.variant ? enqueue(opPlan(f.variant, f.plan, t.plan, l.key), l.uid) : enqueue(opSwap(f.variant, f.plan, t.variant, t.plan, l.key), l.uid);
var oldUid = l.uid, ex = findPT(l.product, to);
if (ex && ex !== l) {
ex.qty = clampQ(ex.qty + l.qty); reprice(ex);
state.lines.splice(state.lines.indexOf(l), 1);
l = ex;
} else {
l.term = to; l.uid = l.product + '-' + to; l.variant = t.variant; l.plan = t.plan || null; l.key = null; l.codes = [];
reprice(l);
}
if (pendingFocus && pendingFocus.indexOf(oldUid) > 0) pendingFocus = pendingFocus.replace(oldUid, l.uid);
var tp = itemOf(l);
done.then(function () { track('cart_plan_change', { items: [tp], from: from, to: to, via: via }); }, function () {});
changed(txt('cart.sr.updated', { amount: money(subtotalShown()) }));
}
function remove(id) {
var l = findLine(id);
if (!l) return;
var at = state.lines.indexOf(l);
state.lines.splice(at, 1);
errors = {}; local = true;
var tr = itemOf(l), tv = l.lineC / 100;
enqueue(opQty(l, 0), false).then(function () { track('remove_from_cart', { items: [tr], value: tv }); }, function () {});
clearTimeout(undoTimer);
undoBuf = { line: l, at: at };
undoTimer = setTimeout(function () { undoBuf = null; render(); }, 5000);
focusKey('undo');
changed(txt('cart.sr.removed', { name: nameOf(l), amount: money(subtotalShown()) }));
}
function undo() {
if (!undoBuf) return;
clearTimeout(undoTimer);
var l = undoBuf.line, at = undoBuf.at;
undoBuf = null; local = true;
var ex = l.product ? findPT(l.product, l.term) : null;
if (ex) { ex.qty = clampQ(ex.qty + l.qty); reprice(ex); }
else state.lines.splice(Math.min(at, state.lines.length), 0, l);
var it = { id: Number(l.variant), quantity: l.qty };
if (l.plan) it.selling_plan = Number(l.plan);
var tu = itemOf(l), tv = l.lineC / 100;
enqueue(opAdd([it], l.props), l.uid).then(function () { track('cart_undo', { items: [tu], value: tv }); }, function () {});
focusKey('rm-' + (ex || l).uid);
changed(txt('cart.sr.added', { name: nameOf(l), amount: money(subtotalShown()) }));
}
function nameOf(l) { return l.product ? P[l.product].name : (l.gen && l.gen.title) || ''; }
var ORDER_KEY = 'opus_order_v1', orderMem = null;
function orderKept() {
var raw = null;
try { raw = win.sessionStorage.getItem(ORDER_KEY); } catch (e) { raw = null; }
if (raw == null) raw = orderMem;
return raw ? String(raw).split(' ').filter(Boolean) : [];
}
function keepOrder() {
var raw = state.lines.map(function (l) { return l.uid; }).join(' ');
if (raw === orderMem) return;
orderMem = raw;
try { win.sessionStorage.setItem(ORDER_KEY, raw); } catch (e) {}
}
function apply(cart, quiet) {
if (!cart || !cart.items) return;
var before = state.lines.length ? state.lines.map(function (l) { return l.uid; }) : orderKept();
var lines = derive(cart);
var pos = function (l) { var i = before.indexOf(l.uid); return i < 0 ? -1 : i; };
lines = lines.map(function (l, i) { return { l: l, i: i }; })
.sort(function (a, b) { return pos(a.l) - pos(b.l) || a.i - b.i; }).map(function (x) { return x.l; });
state.cart = cart; state.lines = lines; local = false;
keepOrder();
var cl = cartLevel(cart);
lastSync = { sub: linesC(), auto: cl.auto, code: cl.code, codeTitle: cl.title, total: cart.total_price, a3: a3Of(cart), a3by: lines.reduce(function (o, l) { if (l.a3C) { var t = (l.term === 'monthly' || l.term === '12') ? l.term : '_o'; o[t] = (o[t] || 0) + l.a3C; } return o; }, {}) };
render();
getQuote();
flushAttrs();
a3Sync(cart);
var f = freeShip();
if (lastFree === false && f === true && state.lines.length) track('cart_ship_threshold', { value: shipBase() / 100, reason: hasSub() ? 'sub' : 'threshold' });
lastFree = f;
if (!quiet) {
try { doc.dispatchEvent(new CustomEvent('opus:cart:updated', { detail: { cart: cart } })); } catch (e) {}
try { win.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
}
}
var lastRefresh = 0;
function refresh() {
lastRefresh = now();
if (pending) return chain;
return getCart().then(function (c) { if (pending) return c; server = c; apply(c); return c; }, function () { return null; });
}
var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'sca_ref', 'ref', 'fbclid', 'ttclid', 'gclid'];
var wantAttrs = null, wantCode = null;
var codeFlight = null;   /* SYSTEM push 18: a posted ?discount= code until the store answers (a3Note) */
var TOUCH_KEY = 'opus_touch_v1', touchMem = null;
function touchGet() {
var raw = null;
try { raw = win.sessionStorage.getItem(TOUCH_KEY); } catch (e) { raw = touchMem; }
if (raw == null) raw = touchMem;
try { var o = raw ? JSON.parse(raw) : null; return o && typeof o === 'object' ? o : null; } catch (e) { return null; }
}
function touchSet(o) {
var raw = JSON.stringify(o);
touchMem = raw;
try { win.sessionStorage.setItem(TOUCH_KEY, raw); } catch (e) {}
}
function tagged(o) { return !!o && ATTR_KEYS.some(function (k) { return !!o[k]; }); }
var OWNED_KEY = 'opus_owned_v1', ownedMem = null, wantExtra = null;
function slugOf(id) { return String((CFG.slugs && CFG.slugs[id]) || id).toLowerCase(); }
function ownIds(list) {
var out = [];
(Array.isArray(list) ? list : String(list == null ? '' : list).split(',')).forEach(function (x) {
var k = String(x == null ? '' : x).trim().toLowerCase();
if (!k) return;
CFG.order.forEach(function (id) { if ((id === k || slugOf(id) === k) && out.indexOf(id) < 0) out.push(id); });
});
return out;
}
function ownedKept() {
var raw = null;
try { raw = win.sessionStorage.getItem(OWNED_KEY); } catch (e) { raw = null; }
if (raw == null) raw = ownedMem;
return ownIds(raw || '');
}
function keepOwned(ids) {
var all = ownIds(ownedKept().concat(ownIds(ids)));
ownedMem = all.join(',');
try { win.sessionStorage.setItem(OWNED_KEY, ownedMem); } catch (e) {}
return all;
}
function ownedFromStore() {
var out = [], o = CFG.ownedRaw;
if (!o || typeof o !== 'object') return out;
var C = (win.OpusCatalog && win.OpusCatalog.products) || {};
var hits = (o.h || []).filter(function (x) { return x != null; }).map(String);
var subs = o.s == null ? '' : (typeof o.s === 'string' ? o.s : JSON.stringify(o.s));
CFG.order.forEach(function (id) {
var c = C[id] || {}, pp = c.prepaid || {}, T = P[id].terms, m = [c.handle, pp.handle, c.productId, pp.productId, slugOf(id)];
for (var k in T) m.push(T[k].pid);
m = m.filter(Boolean).map(String);
var inOrders = hits.some(function (x) { return m.indexOf(x) >= 0; });
var inSubs = !!subs && m.some(function (x) { return /^\d+$/.test(x) ? new RegExp('(^|\\D)' + x + '(\\D|$)').test(subs) : subs.indexOf('"' + x + '"') >= 0 || subs.indexOf('/' + x) >= 0; });
if (inOrders || inSubs) out.push(id);
});
return out;
}
function owned() {
var A = (state.cart && state.cart.attributes) || {};
return ownIds(ownedKept().concat(ownIds(A._opus_owned || ''), ownedFromStore()));
}
function wantAttrsFrom(o) {
if (!o || typeof o !== 'object') return;
for (var k in o) {
if (!/^_[\w-]{1,40}$/.test(k) || o[k] == null) continue;
(wantExtra = wantExtra || {})[k] = String(o[k]).replace(/[<>"'`\\]/g, '').slice(0, 250);
}
}
function readParams() {
var q;
try { q = new URLSearchParams(location.search); } catch (e) { return {}; }
var hv = q.get('have');
if (hv) keepOwned(hv);
var a = {}, any = false;
ATTR_KEYS.forEach(function (k) { var v = q.get(k); v = v ? v.replace(/[<>"'`\\]/g, '').slice(0, 250) : ''; if (v) { a[k] = v; any = true; } });
a._landing = location.pathname;
var kept = touchGet();
if (!kept || (any && !tagged(kept))) { kept = a; touchSet(kept); }
if (tagged(kept)) wantAttrs = kept;
var d = q.get('discount');
if (d && /^[\w-]{2,40}$/.test(d)) wantCode = d;
return { viewcart: q.get('viewcart') === 'true' };
}
function flushAttrs() {
var c = state.cart;
if (!c || !c.item_count) return;
var A = c.attributes || {}, out = {}, n = 0;
if (!A._source && CFG.sourceTag) { out._source = CFG.sourceTag; n++; }
var kept = touchGet();
if (!A._landing && !wantAttrs) { out._landing = (kept && kept._landing) || location.pathname; n++; }
if (wantAttrs) { for (var k in wantAttrs) if (A[k] !== wantAttrs[k]) { out[k] = wantAttrs[k]; n++; } wantAttrs = null; }
var mine = ownedKept();
if (mine.length) {
var had = ownIds(A._opus_owned || ''), both = ownIds(had.concat(mine)).join(',');
if (both !== had.join(',')) { out._opus_owned = both; n++; }
}
if (wantExtra) { for (var x in wantExtra) if (A[x] !== wantExtra[x]) { out[x] = wantExtra[x]; n++; } wantExtra = null; }
var body = n ? { attributes: out } : null;
if (wantCode) {
var got = (c.discount_codes || []).some(function (x) { return String(x.code).toLowerCase() === wantCode.toLowerCase(); });
if (!got) { body = body || {}; body.discount = wantCode; }
wantCode = null;
}
if (!body) return;
var code = body.discount;
if (code) codeFlight = code;
enqueue(function () {
return api('/cart/update.js', body).then(function (c) {
if (code) codeFlight = null;
var d = code && c && (c.discount_codes || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
if (code && (!d || d.applicable === false)) track('cart_error', { code: 'DISCOUNT_NOT_APPLIED', line: null, message: code });
return c;
}, function (e) { if (code) codeFlight = null; throw e; });
}, false);
}
function checkoutUrl() {
var A = (state.cart && state.cart.attributes) || {}, q = [];
var kept = touchGet(), K = tagged(kept) ? kept : {};
['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'].forEach(function (k) {
var v = A[k] || K[k];                                     // the cart's, else this visit's own (CA5)
if (v) q.push(k + '=' + encodeURIComponent(v));
});
return (CFG.checkoutPath || '/checkout') + (q.length ? '?' + q.join('&') : '');
}
var busy = false;
function offline() {
track('cart_error', { code: 'OFFLINE', line: null, message: 'navigator.onLine false' });
errors = { _net: 'OFFLINE' }; focusKey('checkout'); render();      // role=alert announces it once
}
function nav(url) {
if (typeof CFG.navigate === 'function') CFG.navigate(url);
else if (win.OpusCart && typeof win.OpusCart._navigate === 'function') win.OpusCart._navigate(url);
else location.assign(url);
}
/* CART lane (brief 53), regression hunt 4: a change that completes or breaks the set ends in apply(), which queues the
   ALLTHREE update (a3Sync) after CHECKOUT has started waiting; so wait until the queue stops growing (at most 6 rounds) */
function chainIdle(n) {
var c = chain, k = function () { return c === chain || n >= 5 ? null : chainIdle(n + 1); };
return c.then(k, k);   /* a failed step never leaves CHECKOUT stuck (regression hunt 5) */
}
function checkout(btn) {
if (busy || adding || !state.lines.length) return;
if (planHeld) {   /* a plan choice still waiting (planOut) goes to the store first, and the chain below waits for it */
var inPage = !!(btn && pageRoot && pageRoot.contains(btn));
planFlush();
if (btn && !btn.isConnected) btn = (inPage ? pageRoot : root) && (inPage ? pageRoot : root).querySelector('.oc-co');
if (!state.lines.length) return;
}
if (win.navigator && win.navigator.onLine === false) { offline(); return; }
if (errors._net) {
errors = {};
qsa('.oc-foot__err').forEach(function (n) { n.parentNode.removeChild(n); });
}
busy = true;
if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy'); }
chainIdle(0).then(function () {
busy = false;
if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); }
qsa('.oc-co.is-busy').forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); });   /* a repaint during the wait drew a new button busy (footHtml) */
if (!state.lines.length) return;   /* the last line was removed while CHECKOUT waited */
if (win.navigator && win.navigator.onLine === false) { offline(); return; }
track('begin_checkout', cartPayload({ handoff: 'checkout' }));
nav(checkoutUrl());
});
}
var root = null, panel = null, live = null, pageRoot = null, pageEmpty = null, isOpen = false, opener = null, inerted = [], closeGen = 0;
var ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';
var ICON_BIN = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var ICON_TICK = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
function img(p, cls) {
return p.img ? '<img class="' + cls + '" src="' + esc(p.img) + '" alt="" width="' + (p.imgW || 80) + '" height="' + (p.imgH || 80) + '" loading="lazy" decoding="async">' : '';
}
function trio(p) {
return p.parts.map(function (id) { return P[id].img ? '<img class="oc-line__tri" src="' + esc(P[id].img) + '" alt="" width="' + (P[id].imgW || 80) + '" height="' + (P[id].imgH || 80) + '" loading="lazy" decoding="async">' : ''; }).join('');
}
function genImg(g) {
if (!g || !g.img) return '';
var u = String(g.img);
if (/cdn\.shopify|\/cdn\/shop\//.test(u)) u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
return '<img class="oc-line__pic" src="' + esc(u) + '" alt="" width="80" height="80" loading="lazy" decoding="async">';
}
var shipIds = 0;
function shipKind() {
if (abroad()) return 'intl';
if (!state.lines.length) return 'none';
if (state.lines.length && freeShip()) return 'earned';
return 'bar';
}
function shipFigs() {
var s = Math.max(0, shipBase());
return { s: s, pct: Math.min(100, s / CFG.freeOverC * 100).toFixed(1) + '%', away: moneyWhole(Math.max(0, CFG.freeOverC - s)) };
}
/* CART lane (brief 53; Mike, 7 Oct 2026, 4:01pm, items 4 to 7): the bar the original broq.life cart had (a 6px pill on a
   track you can see, a small centred line above and below it; J/cart-reference/broq-theme-cart-files-2026-10-02/live/
   assets_sidecart.css:468-505), his shorter rule line, the away line at the same small size with a period and whole
   dollars ("$36 away"), and never the subscribe nudge. Once shipping is free the bar shows full, with its line. */
function shipBar(pct, now, label, mid) {
return '<div class="oc-ship__bar" role="progressbar" aria-labelledby="' + mid + '" aria-valuemin="0" aria-valuemax="' + (CFG.freeOverC / 100) + '" aria-valuenow="' + now + '" aria-valuetext="' + esc(label) + '"><span style="width:' + pct + '"></span></div>';
}
function shipBlock(kind, mid) {
if (kind === 'none') return '';
if (kind === 'intl') return '<p class="oc-ship__msg">' + htm('cart.ship.intl') + '</p>' + (CFG.intlNote || '');
if (kind === 'earned') return shipBar('100%', CFG.freeOverC / 100, txt('cart.ship.earned'), mid) + '<p class="oc-ship__msg oc-ship__msg--earned" id="' + mid + '">' + htm('cart.ship.earned') + '</p>';
var f = shipFigs();
return '<p class="oc-ship__rule">' + esc(CFG.shipRule) + '</p>' + shipBar(f.pct, f.s / 100, txt('cart.ship.away', { amount: f.away }), mid) +
'<p class="oc-ship__msg" data-oc-away id="' + mid + '">' + htm('cart.ship.away', { amount: f.away }) + '</p>';
}
function paintShip(el) {
var kind = shipKind();
el.hidden = kind === 'none';
if (el.getAttribute('data-kind') !== kind) {
if (!el._n) el._n = 'oc-away-' + (++shipIds);
el.innerHTML = shipBlock(kind, el._n); el.setAttribute('data-kind', kind); return;
}
if (kind !== 'bar') return;
var f = shipFigs(), bar = el.querySelector('.oc-ship__bar');
bar.setAttribute('aria-valuenow', String(f.s / 100));
bar.setAttribute('aria-valuetext', txt('cart.ship.away', { amount: f.away }));
bar.firstChild.style.width = f.pct;
el.querySelector('[data-oc-away]').innerHTML = htm('cart.ship.away', { amount: f.away });
}
/* CART lane (brief 53): prices as Timeline prints them, whole dollars without ".00" ("$63", "$53.55"), the line's price at
   the right on a desktop and under the supply line on a phone (CSS), any struck price beside it */
/* 120 C (Mike, 13 Oct 2026, 3:42pm Pacific: "The price per month needs to be there - and it must be MORE prominent than the
   "switch to" monthly price."): an annual or 24-month line's main price is its price per month ("$49.14/mo", the site's own
   cart.price.mo): the line's price from the store (l.lineC, the same figure "{total} billed once today." prints) divided by its
   plan's months (term.months, the N its "delivered monthly for N months" line prints), to the nearest cent as every per-month
   figure in the theme is rounded (opus-catalog, overlay). A struck price is divided the same way, so both are per month.
   "Pay monthly instead" keeps the line's small grey (.oc-back__b). Monthly, one-time and unknown lines are unchanged. */
function preMonths(l) { var t = term(l); return l.product && isPre(l.term) && t && t.months > 0 && has('cart.price.mo') ? t.months : 0; }
function priceHtml(l) {
var n = preMonths(l);
return '<p class="oc-line__price"><span class="oc-line__now">' + (n ? htm('cart.price.mo', { price: moneyWhole(Math.round(l.lineC / n)) }) : moneyWhole(l.lineC)) + '</span>' + wasHtml(l, n) + '</p>';
}
/* FIX-120C (committee C120, 13 Oct 2026, Baymard and Shleyner): on an annual or 24-month line the struck price carries "/mo"
   too ("$49.14/mo" beside a struck "$63/mo"), the same cart.price.mo as the price beside it; the screen reader hears "Was
   $63/mo", the main price's own pattern. Monthly, one-time and unknown lines (n = 0) are unchanged. */
function wasHtml(l, n) {
var was = lineWas(l);
if (l.origC > l.lineC && !(was > l.origC)) was = l.origC;          // a discount on the line: the store's own before-price
return was && was > l.lineC ? ' <s class="oc-line__was"><span class="oc-sr">' + esc(txt('cart.sr.was')) + ' </span>' + (n ? htm('cart.price.mo', { price: moneyWhole(Math.round(was / n)) }) : moneyWhole(was)) + '</s>' : '';
}
function discTag(l) {
return l.codes && l.codes.length ? '<p class="oc-line__disc">' + htm('cart.discount', { code: l.codes.join(', ') }) + '</p>' : '';
}
function stepper(l, nameId) {
return '<div class="oc-step" role="group" aria-labelledby="' + nameId + '">' +
'<button type="button" class="oc-step__b" data-act="dec" data-uid="' + l.uid + '" data-fk="dec-' + l.uid + '" aria-label="' + esc(txt(l.qty <= 1 ? 'cart.remove' : 'cart.qty.dec')) + '">−</button>' +
'<input class="oc-step__n" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" value="' + l.qty + '" data-act="qty" data-uid="' + l.uid + '" data-fk="qty-' + l.uid + '" aria-label="' + esc(txt('cart.qty')) + '">' +
'<button type="button" class="oc-step__b" data-act="inc" data-uid="' + l.uid + '" data-fk="inc-' + l.uid + '" aria-label="' + esc(txt('cart.qty.inc')) + '"' + (l.qty >= MAXQ ? ' disabled' : '') + '>+</button>' +
'</div>';
}
function prepaidLabel(y, q) {
var lab = txt('cart.plan.prepaid', { total: money(y.totalC * q), perMonth: money(y.priceC * q), pct: y.pct });
return q > 1 ? q + ' × ' + lab : lab;
}
/* CART lane (brief 53; Mike, 7 Oct 2026, 4:01pm, items 8 and 9): Subscribe & Save laid out like Timeline's box (pictures 2
   and 4): the offer in the saving green, "an extra 15%" (it stacks with other discounts), two lines with icons, the
   monthly price against the one-time one, and a real button. Words: Mike's "1-month supply delivered ..." pattern and
   the site's own cancel line. With two or more pouches the form is CFG.manyForm: 'unit' prices and words per pouch as
   Timeline does, 'times' says "2 × ..." and prices the line. */
var ICON_CYCLE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M19.2 9.5A7.5 7.5 0 0 0 5.6 7.4M4.8 14.5a7.5 7.5 0 0 0 13.6 2.1" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/><path d="M5.2 3.6v4h4M18.8 20.4v-4h-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var ICON_PAUSE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.6" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M10.2 9.2v5.6M13.8 9.2v5.6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';
var ICON_PLUS = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.6" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M12 8.4v7.2M8.4 12h7.2" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';
function manyQ(q) { return CFG.manyForm === 'times' && q > 1 ? q : 1; }
function manyPre(q) { return manyQ(q) > 1 ? esc(txt('cart.many', { n: q })) : ''; }
function upBoxHtml(o) {
return '<div class="oc-up' + (o.all ? ' oc-up--all' : '') + '"><div class="oc-up__txt">' +
'<p class="oc-up__h">' + htm('cart.up.h', { pct: o.pct }) + '</p>' +
'<ul class="oc-up__list"><li>' + ICON_CYCLE + '<span>' + o.l1 + '</span></li><li>' + ICON_PAUSE + '<span>' + htm('cart.upgrade.sub') + '</span></li>' +
(o.l3 ? '<li>' + ICON_PLUS + '<span>' + o.l3 + '</span></li>' : '') + '</ul>' +
/* CRO committee (Firestone, Sharma): the saving in dollars, in the words the copy check set (L/review/COPY-SAVE.md):
   {save} inside cart.up.px, or its own line, cart.up.save */
'<p class="oc-up__px">' + htm(o.was > o.now || !has('cart.up.px.flat') ? 'cart.up.px' : 'cart.up.px.flat', { now: moneyWhole(o.now), was: moneyWhole(o.was), save: moneyWhole(o.was - o.now) }) + '</p>' +   /* copy check (COPY-SAVE.md): no "(save $0)" when there is no saving */
(o.was > o.now && has('cart.up.save') ? '<p class="oc-up__save">' + htm('cart.up.save', { save: moneyWhole(o.was - o.now) }) + '</p>' : '') + '</div>' +
'<button type="button" class="oc-up__b" data-act="' + o.act + '"' + (o.uid ? ' data-uid="' + o.uid + '"' : '') + ' data-fk="' + o.fk + '">' + htm('cart.up.b') + (o.sr ? '<span class="oc-sr"> ' + esc(o.sr) + '</span>' : '') + '</button></div>';
}
function upOnes() { return state.lines.filter(function (l) { return l.product && l.term === 'once' && P[l.product].terms.monthly; }); }
/* CART lane (brief 53), regression check 6:30pm: the box takes the all-three saving off, and names it, only when ALLTHREE
   can apply: no code on its way (wantCode, codeFlight) and no other code the store honours on the cart, the same tests
   a3Note uses. The figure grows with the set count; curl on the real store, 7 Oct 2026: 3 sets of each monthly gave
   total_discount 3000 and 5 sets 5000, ALLTHREE applicable both times */
function a3Blocked() {
if (wantCode || codeFlight) return true;
var c = state.cart, all = a3Codes();
if (c && (c.discount_codes || []).some(function (x) { return x.applicable !== false && all.indexOf(String(x.code).toUpperCase()) < 0; })) return true;
if (c && !Array.isArray(c.discount_codes)) {
var cl = cartLevel(c);
if (state.lines.some(function (l) { return l.codes && l.codes.length; }) || (cl.code > 0 && all.indexOf(String(cl.title || '').toUpperCase()) < 0)) return true;
}
return false;
}
function upAllHtml() {
var ones = upOnes();
if (ones.length < 2) return '';
var was = 0, now = 0, pct = 0;
ones.forEach(function (l) { var m = P[l.product].terms.monthly; was += l.origC || l.lineC; now += m.priceC * l.qty; pct = Math.max(pct, m.pct || 0); });
/* design committee, 9pm: three one-time lines moved to Subscribe & Save become a full monthly set, and the store's
   ALLTHREE code then takes its saving, so the offer shows what the cart will charge (equal quantities only; the
   figure comes from the theme, CFG.all3MoC, the same 1000 the pages use; only when no line is monthly already. This
   assumes a code the buyer typed does not apply to subscriptions (the pop-up's OPUS15 showed applicable: false on an
   all-subscription set in the store lane's tests); if one did, ALLTHREE would stay off and this offer would be $10 low) */
var ids = CFG.order || ['broq', 'nmn', 'spmd'], q0 = ones[0].qty, a3l = '';
if (CFG.all3MoC && CFG.all3code && ones.length === ids.length && ids.every(function (id) { return ones.some(function (l) { return l.product === id; }); }) &&
  ones.every(function (l) { return l.qty === q0; }) && !state.lines.some(function (l) { return l.term === 'monthly'; }) && !a3Blocked()) { now -= CFG.all3MoC * q0; a3l = has('cart.all3.line') ? htm('cart.all3.line', { amount: moneyWhole(CFG.all3MoC * q0) }) : ''; }
/* CRO committee (Kohavi, Wiebe, Faris): the $10 is in the price, so the box says so, in the site's own line */
/* copy check Q6.3 (a factual fix): the price counts every pouch, so with any quantity over 1 the line says "This order" */
var many = ones.some(function (l) { return l.qty > 1; }) && has('cart.up.all.l1.many');
return upBoxHtml({ all: true, pct: pct, l1: htm(many ? 'cart.up.all.l1.many' : 'cart.up.all.l1'), l3: a3l || '', now: now, was: was, act: 'upgradeall', fk: 'upall' });
}
/* the one-time line's box (K-3: with two or more one-time lines the one box after the lines does it) */
function upBox(l) {
var p = P[l.product], m = p.terms.monthly;
if (l.term !== 'once' || !m || upOnes().length > 1) return '';
var q = manyQ(l.qty), wasC = q > 1 ? (l.origC || l.lineC) : Math.round((l.origC || l.lineC) / (l.qty || 1));
return upBoxHtml({ pct: m.pct, l1: manyPre(l.qty) + htm('cart.desc.monthly'), now: m.priceC * q, was: wasC, act: 'upgrade', uid: l.uid, fk: 'up-' + l.uid, sr: p.name });
}
/* a delivery line's plan menu: the menu reads as the line's supply sentence ("1-month supply delivered monthly"), a real
   select laid over it so the browser's own list opens (Timeline's dropdown on the line, KB cart-drawer.md: the plan
   editable in place) */
function planSelect(l) {
var p = P[l.product], m = p.terms.monthly, y = p.terms['12'], b = p.terms.bimonthly;
var id = 'ocp-' + l.uid, cur = '';
var opt = function (v, label) { if (l.term === v) cur = label; return '<option value="' + v + '"' + (l.term === v ? ' selected' : '') + '>' + esc(label) + '</option>'; };
var o = '<select class="oc-plan" id="' + id + '" data-act="plan" data-uid="' + l.uid + '" data-fk="plan-' + l.uid + '" aria-label="' + esc(txt('cart.plan.label')) + '">' +
(p.terms.once ? '<optgroup label="' + esc(txt('cart.plan.group.once')) + '">' + opt('once', txt('cart.unit.one')) + '</optgroup>' : '') +
'<optgroup label="' + esc(txt('cart.plan.group.sub', { pct: m.pct })) + '">' + opt('monthly', txt('cart.desc.monthly')) +
(b ? opt('bimonthly', txt('cart.desc.bimonthly')) : '') + '</optgroup>';
var ym = yearSaving(p);
if (CFG.allowPrepaidSwitch && y && ym) o += '<optgroup label="' + esc(txt('cart.plan.group.prepaid', { pct: ym.pct })) + '"><option value="12">' + esc(prepaidLabel(y, l.qty)) + '</option></optgroup>';
o += '</select>';
return '<div class="oc-pl"><span class="oc-pl__v" aria-hidden="true">' + plV(l.qty, cur) + '</span>' + o + '</div>';
}
function plV(q, cur) {
var cut = cur.lastIndexOf(' ');   /* the last word and the chevron never part, so a label that wraps keeps the chevron beside its text */
return manyPre(q) + esc(cur.slice(0, cut + 1)) + '<span class="oc-pl__nw">' + esc(cur.slice(cut + 1)) + ICON_DOWN + '</span>';
}
var ICON_DOWN = '<svg class="oc-pl__i" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true" focusable="false"><path d="M1 1.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
function backBtn(l) {
var m = P[l.product].terms.monthly;
return isPre(l.term) && CFG.allowPrepaidSwitch && m ? '<div class="oc-back"><button type="button" class="oc-back__b" data-act="back" data-uid="' + l.uid + '" data-fk="back-' + l.uid + '">' + htm('cart.plan.prepaid.back', { perMonth: m ? moneyWhole(m.priceC * l.qty) : '' }) + '</button></div>' : '';   /* copy check Q6.2: "Pay monthly instead ($53.55/mo)", priced for the line's quantity */
}
/* the line's kind under its name, as Timeline prints "One-time purchase" or "Subscription" (the site's own plan names) */
function kindOf(l) {
if (l.term === 'once') return txt('cart.plan.once');
if (isDelivery(l.term)) return txt('buy.monthly.name');
return txt(l.term === '12' ? 'cart.kind.year' : 'cart.kind.prepaid');
}
/* the bin with the word beside it on a desktop, the bare bin on a phone (CSS hides the word), as Timeline does */
function rmBtn(l, nameId) {
return '<button type="button" class="oc-line__rm" data-act="rm" data-uid="' + l.uid + '" data-fk="rm-' + l.uid + '" aria-label="' + esc(txt('cart.remove')) + '" aria-describedby="' + nameId + '">' + ICON_BIN + '<span class="oc-line__rmt" aria-hidden="true">' + htm('cart.remove.short') + '</span></button>';
}
function lineHtml(l) {
if (!l.product) return genHtml(l);
var p = P[l.product], t = term(l), nameId = 'ocn-' + l.uid;
var sub;
if (p.bundle) {
var nm = p.parts.map(function (id) { return P[id].name; }).join(' + ');
var sid = l.term === '12' ? 'products.plan.supply.yr' : 'products.plan.supply.mo';
sub = '<p class="oc-line__sub">' + (has(sid) ? htm(sid, { names: nm }) : esc(nm)) + '</p>' +
(has('cart.all3.line') && p.extraC > 0 ? '<p class="oc-line__all3">' + htm('cart.all3.line', { amount: moneyWhole(p.extraC) }) + '</p>' : '') +
(l.term === '12' && CFG.prepaidBilledLine ? '<p class="oc-line__billed">' + htm('cart.prepaid.billed', { total: money(l.lineC) }) + '</p>' : '');
} else if (isDelivery(l.term)) {
sub = planSelect(l);
} else if (isPre(l.term)) {
sub = '<p class="oc-line__sub">' + manyPre(l.qty) + htm('cart.desc.prepaid', { months: t.months }) + '</p>' +
(CFG.prepaidBilledLine ? '<p class="oc-line__billed">' + htm('cart.prepaid.billed', { total: money(l.lineC) }) + '</p>' : '');   /* backBtn: after the stepper (CRO round 2) */
} else {
sub = '<p class="oc-line__sub">' + manyPre(l.qty) + htm('cart.unit.one') + '</p>';
}
var nudge = (CFG.offers.PREPAID_NUDGE && l.term === 'once' && l.qty >= 3 && p.terms['12'])
? '<p class="oc-line__nudge">' + htm('cart.nudge.prepaid', { perMonth: money(p.terms['12'].priceC) }) + '</p>' : '';
var err = errors[l.uid] ? '<p class="oc-line__err" role="alert">' + htm('cart.error.line') + '</p>' : '';
return '<li class="oc-line' + (errors[l.uid] ? ' has-err' : '') + (l.pend ? ' is-pending' : '') + '" data-uid="' + l.uid + '" data-p="' + l.product + '" data-term="' + l.term + '"' + (l.pend ? ' aria-busy="true"' : '') + '>' +
'<a class="oc-line__img' + (p.bundle && !p.img ? ' oc-line__img--trio' : '') + '" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.bundle && !p.img ? trio(p) : img(p, 'oc-line__pic')) + '</a>' +
'<div class="oc-line__main">' +
'<div class="oc-line__id"><h3 class="oc-line__name" id="' + nameId + '"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h3><p class="oc-line__kind">' + esc(kindOf(l)) + '</p></div>' +
priceHtml(l) + rmBtn(l, nameId) +
'<div class="oc-line__desc">' + sub + discTag(l) + '</div>' +
'<div class="oc-line__row">' + stepper(l, nameId) + '</div>' +
(!p.bundle && isPre(l.term) ? backBtn(l) : '') +   /* CRO round 2 (Firestone, Sharma): the way back to monthly sits after the price and stepper */
'</div>' +
'<div class="oc-line__plan">' + upBox(l) + nudge + err + '</div>' +
'</li>';
}
function genHtml(l) {
var g = l.gen, nameId = 'ocn-' + l.uid, err = errors[l.uid] ? '<p class="oc-line__err" role="alert">' + htm('cart.error.line') + '</p>' : '';
return '<li class="oc-line oc-line--gen' + (errors[l.uid] ? ' has-err' : '') + '" data-uid="' + l.uid + '">' +
'<a class="oc-line__img" href="' + esc(g.url || '#') + '" tabindex="-1" aria-hidden="true">' + genImg(g) + '</a>' +
'<div class="oc-line__main">' +
'<div class="oc-line__id"><h3 class="oc-line__name" id="' + nameId + '"><a href="' + esc(g.url || '#') + '">' + esc(g.title) + '</a></h3>' + (g.planName ? '<p class="oc-line__kind">' + esc(g.planName) + '</p>' : '') + '</div>' +
priceHtml(l) + rmBtn(l, nameId) +
'<div class="oc-line__desc">' + discTag(l) + '</div>' +
'<div class="oc-line__row">' + stepper(l, nameId) + '</div>' +
'</div>' + (err ? '<div class="oc-line__plan">' + err + '</div>' : '') +
'</li>';
}
function undoHtml() {
if (!undoBuf) return '';
return '<li class="oc-undo"><span>' + htm('cart.undo.msg', { name: nameOf(undoBuf.line) }) + '</span>' +
'<button type="button" class="oc-undo__b" data-act="undo" data-fk="undo">' + htm('cart.undo.button') + '</button></li>';
}
function suggestion() {
var hasP = {}, from = null;
state.lines.forEach(function (l) { if (!l.product) return; partsOf(l).forEach(function (id) { hasP[id] = true; }); if (!from) from = l; });   // A1: the bundle counts as its three
if (!from) return null;
var own = owned();
var missing = CFG.order.filter(function (id) { return !hasP[id] && own.indexOf(id) < 0; });
var ids = missing.filter(function (id) { return P[id] && P[id].available !== false; });
if (!ids.length) return null;
var g = { ids: ids, from: from, withBroq: !!hasP.broq };
g.plan = isPre(from.term) ? 'monthly' : from.term;
g.qty = isPre(from.term) ? 1 : clampQ(from.qty || 1);
g.complete = ids.length === missing.length;
return g;
}
function planFor(id, plan) { return P[id].terms[plan] ? plan : 'monthly'; }
function planAmt(cents, plan) { return plan === 'monthly' ? txt('cart.price.mo', { price: money(cents) }) : money(cents); }
function planPrice(cents, plan) {
var name = '<span class="oc-x__plan">' + esc(txt(plan === 'monthly' ? 'cart.plan.monthly' : plan === 'bimonthly' ? 'cart.plan.bimonthly' : 'cart.plan.once')) + '</span>';
if (plan === 'monthly') return '<span class="oc-x__amt">' + htm('cart.price.mo', { price: money(cents) }) + '</span> ' + name;
return '<span class="oc-x__amt">' + esc(money(cents)) + '</span> ' + name;
}
function reason(id, complete) {
if (complete && has('cart.xsell.complete')) return htm('cart.xsell.complete', { name: P[id].name });
if (has('cart.xsell.what.' + id)) return htm('cart.xsell.what.' + id);
return esc(P[id].role || '');
}
function cardWhy(g) {
var why;
if (g.ids.length > 1 && g.withBroq && has('cart.xsell.stack')) why = htm('cart.xsell.stack');
else if (g.complete && has('cart.xsell.complete')) why = htm('cart.xsell.complete', { name: g.ids.map(function (id) { return P[id].name; }).join(' + ') });
else why = g.ids.map(function (id) { return reason(id, false); }).join(' ');
return why;
}
function termsHtml(ids, plan) {
if (!isDelivery(plan)) return '';
var k = ids.length > 1 && has('cart.xsell.terms.many') ? 'cart.xsell.terms.many' : 'cart.xsell.terms.one';
return has(k) ? '<p class="oc-x__terms">' + htm(k) + '</p>' : '';
}
function addBtn(ids, plan, qty, cents) {
var both = ids.length > 1, nm = ids.map(function (id) { return P[id].name; });
var lab = has('cart.xsell.button.named')
? htm('cart.xsell.button.named', { name: nm.map(function (x) { return (qty > 1 ? qty + ' × ' : '') + x; }).join(' + '), price: planAmt(cents, plan) })
: htm(both && has('cart.xsell.button.both') ? 'cart.xsell.button.both' : 'cart.xsell.button') + '<span class="oc-sr"> ' + esc(nm.join(', ')) + '</span>';
return '<button type="button" class="oc-x__b" data-oc-add="' + ids.join(' ') + '" data-plan="' + plan + '" data-qty="' + qty + '" data-fk="x-' + ids.join('-') + '">' + lab + '</button>';
}
function freeshipNote(cents) {
if (!has('cart.xsell.freeship') || abroad() || hasSub() || freeShip()) return '';
var c = state.cart;
if (wantCode || (c && (c.total_discount > 0 || (c.cart_level_discount_applications || []).length))) return '';
return shipBase() + cents >= CFG.freeOverC ? ' ' + htm('cart.xsell.freeship') : '';
}
/* SYSTEM (brief 19), design and CRO committees, 6 Oct 2026 (must: Sharma, Rawat, Firestone, Baymard, Elster, Faris):
   the card that completes a whole monthly set says the set's saving, in words already live on /products. The figure is
   the theme's CFG.all3MoC (0 while settings.opus_all3_code is off, so no line). Shown only when the card's own adds make
   the monthly set whole, the same test a3Plan uses: an annual cart's card offers monthly, which makes no set on one
   plan, so it gets no line, and neither does a cart whose monthly set is whole already.
   Push 16 (the regression check on pushes 13 to 15): no line while the cart holds a code the store is honoring, since a3Sync never
   replaces one with ALLTHREE; and two sets save twice ($20), so the figure is CFG.all3MoC times the set count when every
   monthly quantity in the finished set is equal (upAllHtml's rule), else one set's figure.
   Push 17 (the regression check on push 16): before /cart.js answers, the page's own cart lists no codes, so an honored
   code is read from the lines' discounts and the cart-level code, and a ?discount= code still on its way hides the line
   too; and the store was tested at one and two sets only (10AM/ALL-THREE-DISCOUNT-REPORT.md), so the count stops at two.
   Push 18: the ?discount= code also hides the line while its post is out (codeFlight), not only until it is sent */
function a3Note(ids, plan, qty) {
if (!(CFG.all3MoC > 0) || !CFG.all3code || plan !== 'monthly' || !has('cart.xsell.all3')) return '';
if (a3Whole().indexOf('monthly') >= 0 || wantCode || codeFlight) return '';
var c = state.cart, all = a3Codes();
if (c && (c.discount_codes || []).some(function (x) { return x.applicable !== false && all.indexOf(String(x.code).toUpperCase()) < 0; })) return '';
if (c && !Array.isArray(c.discount_codes)) {
var cl = cartLevel(c);
if (state.lines.some(function (l) { return l.codes && l.codes.length; }) || (cl.code > 0 && all.indexOf(String(cl.title || '').toUpperCase()) < 0)) return '';
}
var by = {}, n = {}, order = CFG.order || ['broq', 'nmn', 'spmd'];
state.lines.forEach(function (l) { if (l.product && isSub(l.term)) { (by[l.term] = by[l.term] || {})[l.product] = 1; if (l.term === 'monthly') n[l.product] = (n[l.product] || 0) + (l.qty || 1); } });
by.monthly = by.monthly || {};
ids.forEach(function (id) { if (planFor(id, plan) === 'monthly') { by.monthly[id] = 1; n[id] = (n[id] || 0) + (qty || 1); } });
if (a3Whole(by, order).indexOf('monthly') < 0) return '';
var q = n[order[0]], sets = order.every(function (id) { return n[id] === q; }) ? Math.min(q, 2) : 1;
return '<p class="oc-x__all3">' + htm('cart.xsell.all3', { amount: moneyWhole(CFG.all3MoC * sets) }) + '</p>';
}
function xsellHtml() {
var g = suggestion();
var all = CFG.order.every(function (id) { return state.lines.some(function (l) { return partsOf(l).indexOf(id) >= 0; }); });
var gift = (CFG.offers.STACK_GIFT && all) ? '<p class="oc-gift">' + htm('cart.stackgift') + '</p>' : '';
if (!g) return gift;
var ids = g.ids, plan = planFor(ids[0], g.plan), stack = ids.length > 1, qty = g.qty || 1;
var cents = qty * ids.reduce(function (a, id) { return a + P[id].terms[planFor(id, plan)].priceC; }, 0);
var qn = qty > 1 ? '<span class="oc-x__qty">' + qty + ' ×</span> ' : '';
var names = ids.map(function (id) { return qn + '<a href="' + esc(P[id].url) + '">' + esc(P[id].name) + '</a>'; }).join(' <span aria-hidden="true">+</span> ');
var pics = ids.map(function (id, i) { return '<a class="oc-x__img" href="' + esc(P[id].url) + '" tabindex="-1" aria-hidden="true">' + img(P[id], 'oc-x__pic') + '</a>'; }).join('');
return gift + '<aside class="oc-xs" aria-labelledby="oc-xs-h"><p class="oc-xs__lead" id="oc-xs-h">' + htm('cart.xsell.quiet') + '</p><ul class="oc-xs__list">' +
'<li class="oc-x' + (stack ? ' oc-x--stack' : '') + (has('cart.xsell.button.named') ? ' oc-x--named' : '') + '" data-p="' + ids.join(' ') + '" data-plan="' + plan + '" data-qty="' + qty + '">' +
(stack ? '<span class="oc-x__pair">' + pics + '</span>' : pics) +
'<div class="oc-x__main"><p class="oc-x__name">' + names + '</p>' +
'<p class="oc-x__price">' + planPrice(cents, plan) + '</p>' + a3Note(ids, plan, qty) + '</div>' +
'<p class="oc-x__why">' + cardWhy(g) + freeshipNote(cents) + '</p>' +
addBtn(ids, plan, qty, cents) + termsHtml(ids, plan) + '</li></ul></aside>';
}
function emptyHtml(noTiles) {
var head = '<div class="oc-empty"><p class="oc-empty__h">' + htm('cart.empty.h') + '</p><p class="oc-empty__sub">' + htm('cart.empty.sub', { price: moneyWhole(CFG.freeOverC) }) + '</p>';
if (noTiles) return head + '</div>';
return head +
'<ul class="oc-empty__tiles">' + CFG.order.map(function (id) {
var p = P[id];
return '<li class="oc-tile" data-p="' + id + '"><a class="oc-tile__a" href="' + esc(p.url) + '">' + img(p, 'oc-tile__pic') +
'<span class="oc-tile__name">' + esc(p.name) + '</span><span class="oc-tile__role">' + esc(p.role || '') + '</span></a></li>';   /* design committee (Center, Jen): no three "Shop now" buttons; each tile is one link and SHOP ALL THREE is the only button */
}).join('') + '</ul>' + emptyAllHtml() + '</div>';
}
/* SYSTEM push 20 (coordinator 4:12am, review B): the empty drawer ends like the empty /cart page: "Shop all three" to
   /products#buy and, while the theme's all-three saving is on (CFG.all3MoC, 0 when the code is off), its line in the
   words the cross-sell card uses. data-oc-hop: on /products itself the click closes the drawer and scrolls to #buy */
function emptyAllHtml() {
if (!has('cart.empty.all')) return '';
var a3 = CFG.all3MoC > 0 && CFG.all3code && has('cart.xsell.all3') ? '<p class="oc-empty__a3">' + htm('cart.xsell.all3', { amount: moneyWhole(CFG.all3MoC) }) + '</p>' : '';
return '<p class="oc-empty__all"><a class="oc-empty__btn" href="/products#buy" data-oc-hop>' + htm('cart.empty.all') + '</a></p>' + a3;
}
function addErrHtml() {
var x = errors._add;
if (!x) return '';
var id = x.code === 'SOLDOUT' ? 'cart.error.soldout' : x.code === 'PLAN' ? 'cart.error.plan' : x.code === 'NET' ? 'cart.error.addnet' : 'cart.error.add';
var msg = has(id) ? htm(id) : (x.msg && x.code !== 'NET') ? esc(x.msg) : has('cart.error.add') ? htm('cart.error.add') : htm('cart.error.net');
return '<p class="oc-adderr" role="alert" data-code="' + x.code + '">' + msg + '</p>';
}
function bodyHtml(isPage) {
var ae = addErrHtml();
if (!state.lines.length) {
var u = undoBuf ? '<ul class="oc-lines">' + undoHtml() + '</ul>' : '';
if (ae) return ae + u + (isPage ? '' : emptyHtml(true));      // on /cart the heading already says it is empty
return ae + u + (isPage && pageEmpty != null ? pageEmpty : emptyHtml());
}
/* CART lane (brief 53; Mike, 7 Oct 2026, 4:01pm, item 1): no cross-sell card. Two or more one-time lines share one
   Subscribe & Save box after the list; the notes on cancelling follow, in the drawer and on /cart alike */
return ae + '<ul class="oc-lines">' + state.lines.map(lineHtml).join('') + undoHtml() + '</ul>' + upAllHtml() + waysHtml();
}
function recurHtml(isPage) {
var mo = 0, bi = 0, yrs = {}, yOrd = [];   /* push 26: one prepaid row per plan length (12 and 24 months) */
/* copy committee, 9pm: the ALLTHREE code recurs with the plan, so the repeating rows are restated after its share
   (a full annual set: $1,592.88 billed once today, as Total and checkout say; a monthly set: $145.55 every month) */
var inStep = synced();
state.lines.forEach(function (l) {
var c = (l.origC || l.lineC) - (inStep ? (l.a3C || 0) : 0);
if (l.term === 'monthly') mo += c; else if (l.term === 'bimonthly') bi += c;
else if (isPre(l.term)) { var mm = (term(l) && term(l).months) || 12, g = yrs[mm]; if (!g) { g = yrs[mm] = { c: 0, yn: [] }; yOrd.push(mm); } g.c += c; if (g.yn.indexOf(nameOf(l)) < 0) g.yn.push(nameOf(l)); }
});
/* design committee, 9pm, and review D, 9:35pm: while a change is on its way to the store the lines' code shares are
   stale, so use the last known saving instead, and only while the set is still whole on the same plan it came from */
if (!inStep) { var a3k = a3Kept(); mo -= a3k.monthly || 0; if (yrs[12]) yrs[12].c -= a3k['12'] || 0; }
var out = [];
if (mo && has('cart.total.recurring')) out.push(htm('cart.total.recurring', { amount: money(mo) }));
if (bi && has('cart.total.recurring.bimonthly')) out.push(htm('cart.total.recurring.bimonthly', { amount: money(bi) }));
var ul = function (xs, cls) { return xs.length ? '<ul class="oc-tot__recur' + (cls || '') + '">' + xs.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>' : ''; };
var yrRow = [];
if (has('cart.total.recurring.prepaid')) yOrd.forEach(function (mm) {
var g = yrs[mm];
if (!g.c) return;
var who = state.lines.length > g.yn.length ? '<span class="oc-tot__who">' + esc(g.yn.join(' + ')) + ':</span> ' : '';
yrRow.push(who + htm('cart.total.recurring.prepaid', { total: money(g.c), months: mm }));
});
return ul(out) + (isPage ? wayOutHtml() : '') + ul(yrRow, ' oc-tot__recur--yr');
}
function waysHtml() { var w = wayOutHtml(); return w ? '<div class="oc-ways">' + w + '</div>' : ''; }
function wayOutHtml() {
var n = state.lines.filter(function (l) { return isDelivery(l.term); }).length;
if (!n) return '';
var out = [];
/* brief 53, copy check Q6.1: two or more subscription lines get one note, not the cancel line plus "Each product is its own subscription" */
if (n > 1 && has('cart.ways.many')) out.push(htm('cart.ways.many'));
else {
if (has('cart.bullet.cancel')) out.push(htm('cart.bullet.cancel'));
if (n > 1 && has('products.plan.each') && !manyTermsShown()) out.push(htm('products.plan.each'));
}
return out.map(function (x) { return '<p class="oc-tot__way">' + x + '</p>'; }).join('');
}
function manyTermsShown() {
if (!CFG.xsell) return false;                                 /* brief 53: the cross-sell card is out */
var g = suggestion();
return !!(g && g.ids.length > 1 && isDelivery(planFor(g.ids[0], g.plan)) && has('cart.xsell.terms.many'));
}
function subNoteHtml() {
if (!CFG.subscriber || !has('cart.subscriber.note')) return '';
if (!state.lines.some(function (l) { return isDelivery(l.term); })) return '';
return '<p class="oc-tot__sub"><a href="/account">' + htm('cart.subscriber.note') + '</a></p>';
}
/* CART lane (brief 53; Mike, 7 Oct 2026, 4:01pm, items 11 to 14): no shipping, tax, total or recurring rows. A code or the
   all-three saving shows as its own row, then Subtotal (what the lines come to after them, whole dollars), then a
   CHECKOUT button that says only that. The guarantee lockup sits under it, small and centred, while CFG.cartGuarantee
   is not false (the expert committees' call, lanes/CART.md) */
function footHtml(isPage) {
if (!state.lines.length) return '';
var sub = subtotalShown(), off = codeOff(), title = codeTitle(), a3 = a3Off();
var base = sub - off - a3;
var a3Row = a3 > 0 ? '<div class="oc-sum__r oc-sum__r--disc"><dt>' + (a3Plan() === '12' && has('cart.all3.together.year') ? htm('cart.all3.together.year') : has('cart.all3.together') ? htm('cart.all3.together') : 'All three together') + '</dt><dd>−' + moneyWhole(a3) + '</dd></div>' : '';
var disc = title ? '<div class="oc-sum__r oc-sum__r--disc"><dt>' + htm('cart.discount', { code: title }) + '</dt><dd>' + (off ? '−' + moneyWhole(off) : '') + '</dd></div>' : '';
var allErr = errors._net ? '<p class="oc-foot__err" role="alert">' + htm('cart.error.net') + '</p>'
: errors._all ? '<p class="oc-foot__err" role="alert">' + htm('cart.error.line') + '</p>' : '';
return '<dl class="oc-sum">' + a3Row + disc +
'<div class="oc-sum__r oc-sum__r--sub"><dt>' + htm('cart.total.subtotal') + '</dt><dd data-oc-sub>' + moneyWhole(base) + '</dd></div></dl>' +
subNoteHtml() + allErr +
'<a class="oc-co' + (adding ? ' is-wait' : '') + (busy ? ' is-busy' : '') + '" href="' + esc(checkoutUrl()) + '" data-act="checkout" data-fk="checkout"' + (adding ? ' aria-disabled="true"' : '') + (busy ? ' aria-busy="true"' : '') + '><span class="oc-co__l">' + htm('cart.checkout') + '</span><span class="oc-co__spin" aria-hidden="true"></span></a>' +
(CFG.guaranteeHtml && CFG.cartGuarantee !== false ? '<div class="oc-foot__g">' + glHtml() + '</div>' : '');
}
/* push 26 (Mike, 6 Oct 2026, 8:51am, Q13 "Same 30 days") and push 27 (SITE BUILD 9:51am): in the cart the lockup's prepaid
   line is the plan cards' own sentence, which covers both prepaid plans, whatever the cart holds */
/* CART lane (brief 53), the expert committees' votes (lanes/cart/review/votes/, 7 Oct 2026): Mike's item 14 went to the
   experts. G1 HEAD (10 of 19): only "180-Day Money Back Guarantee" with the shield, small and centred under CHECKOUT. G2
   PREPAID (19 of 19): the prepaid line only when a prepaid plan is in the cart. Two members (Mattar, NN/g) asked for no
   pop-up over the open drawer, so in the cart the lockup is plain text: no button and no info icon. The words and the
   shield come from the site's own lockup (CFG.guaranteeHtml), so they stay Mike's. CFG.cartGuarantee 'full' adds "No
   need to send anything back"; CFG.cartGuaranteePrepaid 'always' or 'never' changes the prepaid rule. */
function glHtml() {
var g = CFG.guaranteeHtml || '';
var icon = (g.match(/<svg class="gl__icon"[\s\S]*?<\/svg>/) || [''])[0];
var head = (g.match(/<span class="gl__head">([^<]*)/) || ['', ''])[1];
var nosend = (g.match(/<span class="gl__nosend">([^<]*)/) || ['', ''])[1];
var pre = has('cart.prepaid.refund') ? htm(refundId()) : (g.match(/<p class="gl__prepaid">([\s\S]*?)<\/p>/) || ['', ''])[1];
if (!head) return '';
var pp = CFG.cartGuaranteePrepaid || 'prepaid';
var showPre = pre && (pp === 'always' || (pp === 'prepaid' && state.lines.some(function (l) { return isPre(l.term); })));
return '<div class="oc-gl2"><p class="oc-gl2__h">' + icon + '<span>' + head + '</span></p>' +
(CFG.cartGuarantee === 'full' && nosend ? '<p class="oc-gl2__n">' + nosend + '</p>' : '') +
(showPre ? '<p class="oc-gl2__p">' + pre + '</p>' : '') + '</div>';
}
/* push 27: the guarantee pop-up (#gl-pop) says the same while the drawer is open and on /cart; its own line comes back when
   the drawer closes, so the page's lockups keep Mike's words */
var popPre = null, popId = null;
function popLine(on) {
var g = glPop(), p = g && g.querySelector('.gl__prepaid');
if (!p || !has('cart.prepaid.refund')) return;
if (on) { if (popPre === null) popPre = p.innerHTML; popId = refundId(); p.innerHTML = htm(popId); }
else if (popPre !== null) { p.innerHTML = popPre; popPre = null; popId = null; }
}
/* FIX-120C (committee C120 must-fix, 13 Oct 2026; Mike's note in _SYSTEM/MIKE-NOTES-LIVE.md, "Annual subscriptions": with a
   24-month plan the line reads "Annual (12- or 24-month) subscriptions"): a cart holding a 24-month line (term "24", the
   drawer's own BROQ 24-Month plan in CFG.products, mapped from the line's variant and selling plan by derive()) carries
   cart.prepaid.refund24, in the footer (glHtml) and in the pop-up while the cart holds it (popLine). Worked out again on
   every render, so removing or switching that line brings back cart.prepaid.refund. */
function refundId() { return has('cart.prepaid.refund24') && state.lines.some(function (l) { return l.term === '24'; }) ? 'cart.prepaid.refund24' : 'cart.prepaid.refund'; }
function popSync() { if (popPre !== null && popId !== refundId()) popLine(true); }
function countBadges() {
var n = count();
qsa('[data-cart-count]').forEach(function (el) { el.textContent = String(n); if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
qsa('[data-cart-open]').forEach(function (el) { el.setAttribute('data-cart-n', String(n)); });
}
/* CART lane (brief 53; Mike, item 3): no number in a circle; "1 item" in small text at the right of the title row */
function countHtml() { return '<p class="oc__count" data-oc-count hidden></p>'; }
function paintCount(container) {
var el = container && container.querySelector('[data-oc-count]');
if (!el) return;
var n = count();
el.textContent = n > 0 ? txt(n === 1 ? 'cart.count.one' : 'cart.count.many', { n: n }) : '';
el.hidden = !(n > 0);
}
function shell() {
return '<div class="oc__overlay" data-oc-close></div>' +
'<div class="oc__panel" role="dialog" aria-modal="true" aria-labelledby="oc-title" tabindex="-1">' +
'<div class="oc__head"><button type="button" class="oc__x" data-oc-close aria-label="' + esc(txt('cart.close')) + '">' + ICON_X + '</button>' +
'<div class="oc__hrow"><h2 class="oc__title" id="oc-title" tabindex="-1">' + htm('cart.title') + '</h2>' + countHtml() + '</div></div>' +
bannerHtml() +
'<div class="oc__ship" data-oc-ship></div>' +
'<div class="oc__body" data-oc-body></div>' +
'<div class="oc__foot" data-oc-foot></div>' +
'<div class="oc-sr" aria-live="polite" aria-atomic="true" data-oc-live></div>' +
'</div>';
}
var BAN_EVERY = 3000, BAN_MS = 400, BAN_EASE = 'cubic-bezier(.25,1,.5,1)';
function banMode() { return CFG.bannerMode === 'off' || CFG.bannerMode === 'broq' ? CFG.bannerMode : (CFG.bannerWords && CFG.bannerWords.head ? 'r9pm' : 'broq'); }
function banStatic() { var W = CFG.bannerWords; return banMode() === 'r9pm' && !!W && (!W.nosend || W.nosend === W.head); }
function bannerHtml() {
if (banMode() === 'off') return '';
var p = has('cart.banner.pause') && !reduced && !banStatic();
return '<div class="oc__banner oc-ban' + (p ? ' oc-ban--p' : '') + '" data-oc-banner data-slide="0"' + (banStatic() ? ' data-static="1"' : '') + '><p class="oc-sr" data-oc-ban-sr></p>' +
'<div class="oc-ban__track" aria-hidden="true"><p class="oc-ban__s is-active"></p><p class="oc-ban__s"></p><p class="oc-ban__s"></p></div>' +
(p ? '<button type="button" class="oc-ban__p" data-oc-ban-p aria-pressed="false" aria-label="' + esc(txt('cart.banner.pause')) + '"></button>' : '') + '</div>';
}
function bannerWho(short) {
var ids = {};
state.lines.forEach(function (l) { if (l.product) ids[l.product] = 1; });
var k = Object.keys(ids);
if (k.length === 1) return P[k[0]].name;
return txt(short ? 'cart.banner.allShort' : 'cart.banner.all');
}
function banOver(el) {
try {
var r = doc.createRange(); r.selectNodeContents(el);
var cs = win.getComputedStyle(el);
return r.getBoundingClientRect().width > el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) + 0.5;
} catch (e) { return el.scrollWidth > el.clientWidth + 1; }
}
function paintBanner(b) {
if (!b) return;
var s = b.querySelectorAll('.oc-ban__s');
var yr = state.lines.some(function (l) { return isPre(l.term); });
b.setAttribute('data-year', yr ? '1' : '0');
if (banMode() === 'r9pm') {
var W = CFG.bannerWords;
var one = banStatic();
s[0].textContent = W.head; s[2].textContent = W.head; s[1].textContent = one ? W.head : W.nosend;
/* SYSTEM push 21 (coordinator 4:16am, review D): the Subscribe & Save offer only while a line could still take it (an
   Opus line bought once) or nothing is chosen yet; a cart that is all subscriptions already has it */
var off = yr || (state.lines.length > 0 && !state.lines.some(function (l) { return l.product && l.term === 'once'; }));
b.hidden = off;
b.querySelector('[data-oc-ban-sr]').textContent = off ? '' : (one ? W.head + '.' : W.head + '. ' + W.nosend + '.');
return;
}
var one = txt('cart.banner.1');   /* 9pm: no guaranteeShort swap (gate N9) */
s[0].textContent = one; s[2].textContent = one;
var who = bannerWho(false);
s[1].textContent = txt('cart.banner.2', { product: who });
if (s[1].clientWidth && banOver(s[1])) { who = bannerWho(true); s[1].textContent = txt('cart.banner.2', { product: who }); }
b.setAttribute('data-who', who);
b.querySelector('[data-oc-ban-sr]').textContent = one + '. ' + s[1].textContent + '.';
}
function banRotor(b) {
if (!b) return null;
if (b._r) return b._r;
var r = b._r = { b: b, tr: b.querySelector('.oc-ban__track'), s: b.querySelectorAll('.oc-ban__s'), i: 0, timer: null, end: null, hold: 0, user: false, x0: null };
var pause = function () { r.hold++; }, resume = function () { r.hold = Math.max(0, r.hold - 1); if (!r.hold && r.timer) banTick(r); };
b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(); });
b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resume(); });
var onCtl = function (e) { return !!(e.target && e.target.hasAttribute && e.target.hasAttribute('data-oc-ban-p')); };
b.addEventListener('focusin', function (e) { if (!onCtl(e)) pause(); });
b.addEventListener('focusout', function (e) { if (!onCtl(e)) resume(); });
var ctl = b.querySelector('[data-oc-ban-p]');
if (ctl) ctl.addEventListener('click', function () {
r.user = !r.user;
ctl.setAttribute('aria-pressed', r.user ? 'true' : 'false');
if (!r.user && r.timer) banTick(r);
});
b.addEventListener('touchstart', function (e) { var t0 = e.touches && e.touches[0]; r.x0 = t0 ? t0.clientX : null; r.y0 = t0 ? t0.clientY : null; }, { passive: true });
b.addEventListener('touchend', function (e) {
var t = e.changedTouches && e.changedTouches[0];
if (r.x0 == null || !t || reduced || !r.timer) return;
var dx = t.clientX - r.x0, dy = t.clientY - r.y0; r.x0 = null;
if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
if (dx < 0) banStep(r, 1); else banStep(r, -1);
banTick(r);
}, { passive: true });
return r;
}
function banActive(r, k, fade) {
for (var j = 0; j < r.s.length; j++) {
if (!fade) r.s[j].style.transition = 'none';
r.s[j].classList.toggle('is-active', j === k);
}
if (!fade) { void r.tr.offsetWidth; for (var m = 0; m < r.s.length; m++) r.s[m].style.transition = ''; }
r.b.setAttribute('data-slide', String(k % 2));
}
function banMove(r, i, animate) {
r.i = i;
r.tr.style.transition = animate ? 'transform ' + BAN_MS + 'ms ' + BAN_EASE : 'none';
r.tr.style.transform = 'translateX(' + (-100 * i) + '%)';
}
function banStep(r, dir) {
if (r.end) return;
var to = r.i + (dir || 1);
if (to < 0) { banActive(r, 2, false); banMove(r, 2, false); void r.tr.offsetWidth; to = 1; }
banMove(r, to, true);
r.end = setTimeout(function () {
r.end = null;
if (r.i === 2) { banMove(r, 0, false); void r.tr.offsetWidth; }
banActive(r, r.i, true);
}, BAN_MS);
}
function banTick(r) {
clearInterval(r.timer);
r.timer = setInterval(function () { if (!r.hold && !r.user && !doc.hidden) banStep(r, 1); }, BAN_EVERY);
}
function banStart(b) {
var r = banRotor(b); if (!r) return;
banStop(b);
r.hold = 0;
paintBanner(b);
banMove(r, 0, false);
banActive(r, 0, false);
if (reduced || banStatic()) return;
banTick(r);
}
function banStop(b) { var r = b && b._r; if (r) { clearInterval(r.timer); r.timer = null; clearTimeout(r.end); r.end = null; } }
function ensureRoot() {
if (root) return;
root = doc.createElement('div');
root.id = 'opus-cart';
root.className = 'oc';
root.hidden = true;
root.innerHTML = shell();
doc.body.appendChild(root);
panel = root.querySelector('.oc__panel');
live = root.querySelector('[data-oc-live]');
}
var painting = 0;
function paint(container) {
if (!container) return;
var a = doc.activeElement, fk = pendingFocus || (a && container.contains(a) ? a.getAttribute('data-fk') : null);
var body = container.querySelector('[data-oc-body]');
var scroll = body ? body.scrollTop : 0;
paintShip(container.querySelector('[data-oc-ship]'));
/* lane 69 (Mike, 8 Oct 2026: on a phone the cart's pictures flicker as it opens, as if reloaded): every render rebuilt every
   picture, so each one could show empty for a frame or more until the browser had it again (open() renders, then refresh()
   renders again when the store answers). A picture whose tag is exactly the same as before now keeps its old, already shown
   element; only new or changed pictures are new elements. */
var keepImg = {};
Array.prototype.forEach.call(body.querySelectorAll('img'), function (im) { (keepImg[im.outerHTML] = keepImg[im.outerHTML] || []).push(im); });
painting++;   /* Chrome fires focusout on a focused menu as it is replaced; planOut ignores those (regression check 6:40pm) */
try { body.innerHTML = bodyHtml(container === pageRoot); } finally { painting--; }
Array.prototype.forEach.call(body.querySelectorAll('img'), function (im) { var o = keepImg[im.outerHTML]; if (o && o.length) im.parentNode.replaceChild(o.shift(), im); });
container.querySelector('[data-oc-foot]').innerHTML = footHtml(container === pageRoot);
container.classList.toggle('oc--empty', !state.lines.length);
if (container === pageRoot) pageHead();
paintCount(container);
paintBanner(container.querySelector('[data-oc-banner]'));
body.scrollTop = scroll;
if (fk && (container === pageRoot || isOpen)) {
var el = container.querySelector('[data-fk="' + fk + '"]');
if (!el && /^(dec|inc|qty|plan|up|back|rm|year)-/.test(fk)) el = container.querySelector('[data-uid="' + fk.replace(/^[a-z]+-/, '') + '"]');
if (!el) el = container.querySelector('.oc__title, .oc-page__h');
if (el) try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
}
}
function pageHead() {
var h = pageRoot && pageRoot.querySelector('[data-oc-h]');
if (!h) return;
var k = !state.lines.length && has('cart.empty.h') ? 'empty' : 'full';
if (h.getAttribute('data-k') === k) return;
h.setAttribute('data-k', k);
h.innerHTML = (k === 'empty' ? htm('cart.empty.h') : htm('cart.title'));
countBadges();
}
function render() {
countBadges();
if (root) paint(root);
if (pageRoot) paint(pageRoot);
popSync();   /* FIX-120C: the pop-up's refund line follows the cart (a 24-month line added or removed) */
pendingFocus = null;
}
function say(msg) {
var el = (isOpen && live) || (pageRoot && pageRoot.querySelector('[data-oc-live]')) || live;
if (!el) return;
el.textContent = '';
setTimeout(function () { el.textContent = msg; }, 60);
}
var pushed = false;
function open(from) {
if (pageRoot) {                                          // on /cart the page is the cart
var h = pageRoot.querySelector('.oc-page__h'); if (h) try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
return;
}
ensureRoot();
if (isOpen) { render(); return; }
opener = from || doc.activeElement;
isOpen = true;
if (glPopOpen()) try { glPop().hidePopover(); } catch (e) {}   /* push 28: a pop-up opened from a page lockup closes first */
popLine(true);
render();
root.hidden = false;
void root.offsetWidth;
root.classList.add('is-open');
banStart(root.querySelector('[data-oc-banner]'));
doc.documentElement.classList.add('oc-lock');
doc.body.classList.add('cart-open');
inerted = [];
/* push 28: #gl-pop sits inside a page section, so keep its ancestors live and make their other children inert, level by
   level; the pop-up opened from the drawer's lockup can then be tapped and read */
var gp = glPop(), keep = [];
for (var a = gp; a && a !== doc.body; a = a.parentNode) keep.push(a);
(function walk(list) {
Array.prototype.forEach.call(list, function (el) {
if (el === root || el.tagName === 'SCRIPT') return;
if (keep.indexOf(el) >= 0) { if (el !== gp) walk(el.children); return; }
if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); inerted.push(el); }
});
})(doc.body.children);
var t = root.querySelector('.oc__title');
setTimeout(function () {
var a = doc.activeElement;
if (!isOpen || (a && a !== panel && panel.contains(a))) return;
try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
}, reduced ? 0 : 30);
try { if (!(history.state && history.state.opusCart)) { history.pushState({ opusCart: 1 }, ''); pushed = true; } } catch (e) {}
track('view_cart', cartPayload());
if (!pending && now() - lastRefresh > 2000) refresh();
}
function close(fromPop) {
if (!isOpen) return;
isOpen = false;
var op = opener, gp = glPop(), gen = ++closeGen;
if (gp && (glPopOpen() || root.querySelector('[data-gl-pop][aria-expanded="true"]'))) {   /* pushes 31 to 33: the pop-up never outlives the drawer. Open, or closing (a real click outside light-dismissed it; its lockup keeps aria-expanded until the site script's toggle handler runs): that handler then refocuses the lockup inside the closing drawer, so focus goes back to the opener after it */
var back = function (e) {
if (e && e.newState === 'open') return;
var ae = doc.activeElement;
if (gen !== closeGen || isOpen || glPopOpen() || !op || !op.focus || !doc.contains(op)) return;   /* push 34: never pull focus out of a pop-up opened again since */
if (!ae || ae === doc.body || root.contains(ae) || gp.contains(ae)) { try { op.focus({ preventScroll: true }); } catch (e2) { op.focus(); } }
};
gp.addEventListener('toggle', back);
setTimeout(back, 150);
setTimeout(function () { back(); gp.removeEventListener('toggle', back); }, 600);
if (glPopOpen()) {
if (typeof gp.hidePopover === 'function') { try { gp.hidePopover(); } catch (e) {} }
else { gp.classList.remove('glpop--open'); qsa('[data-gl-pop][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
}
}
popLine(false);
if (errors._add) { delete errors._add; render(); }
root.classList.remove('is-open');
banStop(root.querySelector('[data-oc-banner]'));
doc.documentElement.classList.remove('oc-lock');
doc.body.classList.remove('cart-open');
inerted.forEach(function (el) { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); });
inerted = [];
setTimeout(function () { if (!isOpen) root.hidden = true; }, reduced ? 0 : 260);
if (opener && opener.focus && doc.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
opener = null;
if (!fromPop && pushed) { pushed = false; try { if (history.state && history.state.opusCart) history.back(); } catch (e) {} }
pushed = false;
}
function glPop() { return CFG.glPopId ? doc.getElementById(CFG.glPopId) : null; }
function glPopOpen() {
var g = glPop();
if (!g) return false;
try { return g.matches(':popover-open'); } catch (e) { return g.classList.contains('glpop--open'); }
}
function trap(e) {
if (!isOpen) return;
if (glPopOpen() && e.key === 'Tab' && glPop().contains(doc.activeElement)) {   /* push 31: Tab out of the pop-up goes to the drawer's close button, not BODY */
var pf = qsa('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', glPop()).filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
if (pf.length && doc.activeElement === (e.shiftKey ? pf[0] : pf[pf.length - 1])) { var cx = root && root.querySelector('.oc__x'); if (cx) { e.preventDefault(); cx.focus(); } }
return;
}
if (glPopOpen() && (e.key === 'Escape' || e.key === 'Esc')) return;
if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
if (e.key !== 'Tab') return;
var f = qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])', panel)
.filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
if (!f.length) { e.preventDefault(); return; }
var first = f[0], last = f[f.length - 1], a = doc.activeElement;
if (!panel.contains(a)) { e.preventDefault(); first.focus(); return; }
if (e.shiftKey && (a === first || a === panel || a.classList.contains('oc__title'))) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
}
function inCart(el) { return (root && root.contains(el)) || (pageRoot && pageRoot.contains(el)); }
function onClick(e) {
if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
var t = e.target;
var addEl = t.closest && t.closest('[data-oc-add]');
if (addEl && inCart(addEl)) {
e.preventDefault();
var ids = String(addEl.getAttribute('data-oc-add') || '').split(/\s+/).filter(Boolean), plan = addEl.getAttribute('data-plan') || 'monthly';
var xq = clampQ(parseInt(addEl.getAttribute('data-qty'), 10) || 1);
focusKey('checkout');
win.OpusCart.addMany(ids.map(function (id) { return { product: id, plan: planFor(id, plan), qty: xq }; }), { source: 'xsell', open: false }).catch(function () {});
return;
}
var opn = t.closest && t.closest('[data-cart-open], a[href="/cart"], a[href="/cart/"]');
if (opn && !inCart(opn)) { e.preventDefault(); open(opn); return; }
if (t.closest && t.closest('[data-oc-close]')) { e.preventDefault(); close(); return; }
var hop = t.closest && t.closest('[data-oc-hop]');
if (hop && inCart(hop) && isOpen) {
var hu = hop.getAttribute('href') || '', hi = hu.indexOf('#');
if (hi > 0 && hu.slice(0, hi) === location.pathname.replace(/\/$/, '') && doc.getElementById(hu.slice(hi + 1))) {
e.preventDefault();
var tid = hu.slice(hi + 1), went = false, back = pushed;
var go = function () {
if (went) return; went = true; win.removeEventListener('popstate', later);
var el = doc.getElementById(tid); if (!el) return;
el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
var fe = el.querySelector('h2, h3') || el;               /* push 23: the section's heading, not the whole section */
if (!fe.hasAttribute('tabindex')) { fe.setAttribute('tabindex', '-1'); fe.style.outline = 'none'; }
try { fe.focus({ preventScroll: true }); } catch (x) {}
};
var later = function () { setTimeout(go, 0); };
if (back) win.addEventListener('popstate', later);
close();
setTimeout(go, back ? 400 : (reduced ? 50 : 300));
return;
}
}
var act = t.closest && t.closest('[data-act]');
if (!act || !inCart(act)) return;
if (act.closest('.oc-line.is-pending')) { e.preventDefault(); return; }   // waiting on the store
var a = act.getAttribute('data-act'), uid = act.getAttribute('data-uid');
if (a === 'dec') { var l1 = findLine(uid); if (l1) { if (l1.qty <= 1) remove(uid); else setQty(uid, l1.qty - 1); } }
else if (a === 'inc') { var l2 = findLine(uid); if (l2) setQty(uid, l2.qty + 1); }
else if (a === 'rm') remove(uid);
else if (a === 'undo') undo();
else if (a === 'upgrade') {
var lu = findLine(uid);
focusKey('plan-' + (lu ? lu.product + '-monthly' : uid)); setTerm(uid, 'monthly', 'upgrade_button');
}
else if (a === 'upgradeall') {
var ones = upOnes();
if (ones.length) focusKey('plan-' + ones[0].product + '-monthly');
ones.forEach(function (l) { setTerm(l.uid, 'monthly', 'upgrade_all'); });
}
else if (a === 'back') { var lb = findLine(uid); focusKey('plan-' + (lb ? lb.product + '-monthly' : uid)); setTerm(uid, 'monthly', 'prepaid_back'); }
else if (a === 'toyear') { var ly = findLine(uid); focusKey('back-' + (ly ? ly.product + '-12' : uid)); setTerm(uid, '12', 'prepaid_link'); }
else if (a === 'checkout') { e.preventDefault(); checkout(act); }
}
function formItems(fd) {
var one = fd.get('id'), out = [], idx = {};
if (one) {
var it = { id: Number(one), quantity: clampQ(fd.get('quantity') || 1) };
if (fd.get('selling_plan')) it.selling_plan = Number(fd.get('selling_plan'));
out.push(it);
}
fd.forEach(function (v, k) {
var m = /^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/.exec(k);
if (!m) return;
var o = idx[m[1]] || (idx[m[1]] = {});
o[m[2]] = v;
});
Object.keys(idx).forEach(function (i) {
var o = idx[i];
if (!o.id) return;
var it = { id: Number(o.id), quantity: clampQ(o.quantity || 1) };
if (o.selling_plan) it.selling_plan = Number(o.selling_plan);
out.push(it);
});
return out.filter(function (x) { return x.id > 0; });
}
function onSubmit(e) {
var f = e.target;
if (e.defaultPrevented || !f || f.tagName !== 'FORM' || inCart(f)) return;
var path = '';
var sb = e.submitter, act = (sb && sb.getAttribute && sb.getAttribute('formaction')) || f.getAttribute('action') || '';
try { path = new URL(act, location.href).pathname; } catch (x) { return; }
if (!/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/add(\.js)?\/?$/i.test(path)) return;
var fd;
try { fd = new FormData(f, e.submitter || undefined); } catch (x) { try { fd = new FormData(f); } catch (y) { return; } }
var items = formItems(fd);
if (!items.length) return;
e.preventDefault();
if (f.getAttribute('aria-busy') === 'true') return;          // a second press while the first is with the store
f.setAttribute('aria-busy', 'true');
var src = fd.get('properties[_src]') || f.getAttribute('data-source') || 'form';
var done = function () { f.removeAttribute('aria-busy'); };
addItems(items, { source: src, opener: sb || f }).then(done, done);
}
function onChange(e) {
var el = e.target;
if (!el.getAttribute || !inCart(el)) return;
if (el.closest && el.closest('.oc-line.is-pending')) { render(); return; }
var a = el.getAttribute('data-act'), uid = el.getAttribute('data-uid');
if (a === 'plan') {
if (planVia === 'key') { planShow(el); return; }   /* a keyboard choice waits for Enter or for focus to leave (planKey, planOut) */
planApply(el, true);
} else if (a === 'qty') { focusKey('qty-' + uid); setQty(uid, el.value); }
}
/* design committee (Roselli, BROKEN, WCAG 3.2.2; Ballasy): in Chrome, Edge and Firefox on Windows the arrow keys on a closed
   select fire change on every press, so arrowing through the plan menu applied each plan as it passed it (the first Up from
   monthly made the line one-time and moved focus to SUBSCRIBE). A pointer or touch choice still applies at once; a keyboard
   choice shows in the box and applies on Enter or when focus leaves the menu; Escape puts the line's own plan back. */
var planVia = '';
function isPlan(el) { return !!(el && el.classList && el.classList.contains('oc-plan') && inCart(el)); }
function planShow(el) {
var l = findLine(el.getAttribute('data-uid')), o = el.options[el.selectedIndex], v = el.parentNode && el.parentNode.querySelector('.oc-pl__v');
if (l && o && v) v.innerHTML = plV(el.value === '12' ? 1 : l.qty, o.text);
}
function planApply(el, moveFocus) {
var uid = el.getAttribute('data-uid'), to = el.value, l = findLine(uid);
planVia = '';
if (planHeld && planHeld.uid === uid) {   /* this menu's own choice replaces its waiting one */
if (planHeld.to === to) { if (!planPressing || now() - planPressAt >= 1500) planFlush(); return; }   /* the same choice: send it now (a change fired after its focusout), unless a press elsewhere is under way (its click flushes it) */
planHeld = null;
}
if (!l || l.term === to || el.getAttribute('data-done') === to) return;
el.setAttribute('data-done', to);
if (planHeld) planFlush();   /* another line's waiting choice goes first */
var pid = l.product;
if (moveFocus) { if (to === '12') focusKey('back-' + pid + '-12'); else if (to === 'once') focusKey('up-' + pid + '-once'); else focusKey('plan-' + pid + '-' + to); }
else { var ae = doc.activeElement, fk = ae && inCart(ae) ? ae.getAttribute('data-fk') : null; if (fk) focusKey(fk); }
setTerm(uid, to, 'select');
}
function planKey(e) {
var el = e.target;
planPressing = false;   /* a key: any focus move now is the keyboard's (a press that opened a list may never send pointerup) */
if (!isPlan(el)) return;
if (e.key === 'Enter') { if (planVia === 'key') { e.preventDefault(); planApply(el, true); } return; }
if (e.key === 'Escape' || e.key === 'Esc') {
var l = findLine(el.getAttribute('data-uid'));
if (planVia === 'key' && l && el.value !== l.term) { e.preventDefault(); e.stopImmediatePropagation(); el.value = l.term; planShow(el); planVia = ''; }
return;
}
if (e.key !== 'Tab' && e.key !== 'Shift') planVia = 'key';
}
/* regression check, 6:30pm: a choice left waiting is held by the line's uid (planHeld), not by the menu, so a repaint
   between focusout and the apply cannot strand it; it is waiting whenever the menu shows a plan the line does not have
   and has not been sent (not only after a key, so a press on another line's menu applies it too). When focus leaves
   because of a press on another control, the choice applies after that press's click, so the repaint does not swallow
   the click (+, Remove, Undo); CHECKOUT applies it first and then waits for it (checkout) */
var planHeld = null, planPressing = false, planPressAt = 0;
function planPtr(e) {
planPressing = true; planPressAt = now();   /* until pointerup, pointercancel (planAfter) or a key (planKey) */
if (isPlan(e.target)) planVia = 'pointer';
}
function planWaiting(el) {
var l = findLine(el.getAttribute('data-uid'));
return !!(l && el.value && el.value !== l.term && el.getAttribute('data-done') !== el.value);
}
function planFlush() {
var h = planHeld;
planHeld = null;
if (!h) return;
var l = findLine(h.uid);
if (!l || l.term === h.to) return;
var ae = doc.activeElement, fk = ae && inCart(ae) ? ae.getAttribute('data-fk') : null;
if (fk) focusKey(fk);   /* the control focus landed on keeps it */
setTerm(h.uid, h.to, 'select');
}
function planOut(e) {
var el = e.target;
if (!isPlan(el) || painting) return;   /* a repaint is not focus leaving: the new menu shows the line's own plan */
if (planWaiting(el)) {
planVia = '';
planHeld = { uid: el.getAttribute('data-uid'), to: el.value };
el.setAttribute('data-done', el.value);
}
if (!planHeld) return;
if (planPressing && now() - planPressAt < 1500) return;   /* a press moved focus: its click (or, failing that, its pointerup) applies it (planAfter) */
setTimeout(planFlush, 0);   /* after focus lands */
}
/* not while focus is on a plan menu: a press there opens its list, and that menu's own change or focusout applies it */
function planAfter(e) {
if (e.type !== 'click') planPressing = false;
if (planHeld && !isPlan(doc.activeElement)) setTimeout(planFlush, e.type === 'click' ? 0 : 300);
}
function onKey(e) {
if (e.key === 'Enter' && e.target && e.target.getAttribute && e.target.getAttribute('data-act') === 'qty') {
e.preventDefault();
if (e.target.closest && e.target.closest('.oc-line.is-pending')) return;   // waiting on the store
focusKey('qty-' + e.target.getAttribute('data-uid')); setQty(e.target.getAttribute('data-uid'), e.target.value);
}
}
function chatLauncher() {
var mq = win.matchMedia ? win.matchMedia('(max-width:599px)') : null;
if (!mq) return;
var html = doc.documentElement, host = null, btn = null, raf = 0, seen = null;
function find() {
host = doc.getElementById('smart-bot-container');
var sr = host && host.shadowRoot;
btn = sr ? sr.querySelector('[aria-haspopup="dialog"]') : null;
if (sr && seen !== sr && win.MutationObserver) {
seen = sr;
new MutationObserver(later).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded', 'style'] });
}
}
function sync() {
raf = 0;
if (!btn || !btn.isConnected) find();
var phone = mq.matches;
var live = !!(btn && (btn.getAttribute('aria-expanded') === 'true' || (host && doc.activeElement === host)));
var vh = win.innerHeight || html.clientHeight || 0;
var y = win.pageYOffset || html.scrollTop || 0;
var end = y >= html.scrollHeight - vh - 2;
var hide = phone && !live && (html.classList.contains('sheet-open') || (y < vh / 2 && !end));
if (html.classList.contains('oc-chat-wait') !== hide) html.classList.toggle('oc-chat-wait', hide);
if (!btn) return;
var want = '';
if (phone && !live) {
var bar = doc.querySelector('#sticky.sticky--on, .sbox__bar.is-on');
var h = bar ? bar.offsetHeight : 0;
var up = h ? h + 8 - (parseFloat(win.getComputedStyle(btn).bottom) || 0) : 0;
if (up > 0) want = '0px ' + (-Math.ceil(up)) + 'px';
}
if ((btn.style.translate || '') !== want) btn.style.translate = want;
}
function later() { if (!raf) raf = win.requestAnimationFrame ? win.requestAnimationFrame(sync) : setTimeout(sync, 16); }
win.addEventListener('scroll', later, { passive: true });
win.addEventListener('resize', later);
if (mq.addEventListener) mq.addEventListener('change', later); else if (mq.addListener) mq.addListener(later);
if (win.MutationObserver) {
new MutationObserver(later).observe(html, { attributes: true, attributeFilter: ['class'] });
if (doc.body) new MutationObserver(function () { if (!host || !host.isConnected) later(); }).observe(doc.body, { childList: true });
}
doc.addEventListener('focusin', later);
doc.addEventListener('focusout', later);
sync();
}
function boot() {
try { chatLauncher(); } catch (e) {}
overlay();
all3();                                                      // A1: after the live prices, which it sums
index();
var params = readParams();
if (CFG.cart && CFG.cart.items) { server = CFG.cart; apply(CFG.cart, true); }
lastFree = freeShip();
pageRoot = doc.querySelector('[data-cart-page]');
if (pageRoot) {
var pe = pageRoot.querySelector('[data-oc-pempty]');
if (pe) { qsa('.oc-nojs', pe).forEach(function (n) { n.parentNode.removeChild(n); }); pe.removeAttribute('hidden'); pageEmpty = pe.outerHTML; }
pageRoot.innerHTML = '<div class="oc__hrow"><h1 class="oc-page__h" tabindex="-1" data-oc-h>' + htm('cart.title') + '</h1>' + countHtml() + '</div>' +
bannerHtml() +
'<div class="oc__ship" data-oc-ship></div><div class="oc__body" data-oc-body></div><div class="oc__foot" data-oc-foot></div>' +
'<div class="oc-sr" aria-live="polite" aria-atomic="true" data-oc-live></div>';
pageRoot.classList.add('is-live');
popLine(true);
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { popLine(true); });
}
ensureRoot();
render();
if (pageRoot) banStart(pageRoot.querySelector('[data-oc-banner]'));
win.addEventListener('resize', function () { qsa('[data-oc-banner]').forEach(paintBanner); });
doc.addEventListener('click', onClick);
doc.addEventListener('submit', onSubmit);
doc.addEventListener('change', onChange);
doc.addEventListener('keydown', onKey);
doc.addEventListener('keydown', planKey, true);   // before trap, so Escape on a pending plan choice puts it back without closing the drawer
doc.addEventListener('keydown', trap, true);
doc.addEventListener('pointerdown', planPtr, true);
doc.addEventListener('focusout', planOut);
win.addEventListener('click', planAfter);
win.addEventListener('pointerup', planAfter);
win.addEventListener('pointercancel', planAfter);
win.addEventListener('popstate', function () { if (isOpen) close(true); });
win.addEventListener('cart:open', function () { open(); });
win.addEventListener('cart:refresh', function () { refresh(); });
win.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
doc.addEventListener('visibilitychange', function () { if (!doc.hidden && now() - lastRefresh > 2000) refresh(); });
refresh().then(function () { if (params.viewcart) open(); });
}
win.OpusCart = {
add: function (a, b, c, d) { return typeof a === 'string' ? addByKey(a, b, c, d) : addItems(a, b); },
addMany: function (list, opts) {
var items = [];
(list || []).forEach(function (x) { var t = P[x.product || x.id] && P[x.product || x.id].terms[x.plan || 'monthly']; if (t) { var it = { id: Number(t.variant), quantity: clampQ(x.qty || 1) }; if (t.plan) it.selling_plan = Number(t.plan); items.push(it); } });
return addItems(items, opts);
},
addAll: function (plan, opts) { return win.OpusCart.addMany(CFG.order.map(function (id) { return { product: id, plan: plan || 'monthly', qty: 1 }; }), opts); },
open: function () { open(); },
close: function () { close(); },
toggle: function () { isOpen ? close() : open(); },
refresh: function () { return refresh(); },
remove: remove, setQty: setQty, setPlan: function (u, t) { setTerm(u, t, 'api'); }, undo: undo,
clear: function () { errors = {}; local = true; state.lines = []; render(); return enqueue(function () { return api('/cart/clear.js', {}); }, false); },
setCountry: function (cc) { state.country = cc ? String(cc).toUpperCase() : null; quote.key = null; render(); getQuote(); },
checkout: function () { checkout(root && root.querySelector('.oc-co')); },
settled: function () { return chain.then(function () { return chain; }); },
state: function () { return JSON.parse(JSON.stringify({ lines: state.lines, country: state.country, cart: state.cart, pending: pending })); },
lines: function () { return state.lines.map(function (l) { return { uid: l.uid, product: l.product, term: l.term, qty: l.qty, variant: l.variant, plan: l.plan, cents: l.lineC, key: l.key }; }); },
subtotal: function () { return subtotalShown(); },
freeShipping: function () { return freeShip(); },
shipping: function () { return shipC(); },
checkoutUrl: checkoutUrl,
isOpen: function () { return isOpen; },
all3: function () { var a = P.all3; return a ? JSON.parse(JSON.stringify({ parts: a.parts, extraC: a.extraC, onceC: a.onceC, monthly: a.terms.monthly, '12': a.terms['12'] })) : null; },
catalog: CFG,
_navigate: null,
};
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
